export const common = {
  // Common
  'common.edit': 'Edit',
  'common.delete': 'Delete',
  'common.save': 'Save',
  'common.cancel': 'Cancel',
  'common.close': 'Close',
  'common.loading': 'Loading...',
  'common.error': 'Error',
  'common.success': 'Success',
  'common.confirm': 'Confirm',
  'common.back': 'Back',
  'common.next': 'Next',
  'common.previous': 'Previous',
  'common.submit': 'Submit',
  'common.search': 'Search',
  'common.filter': 'Filter',
  'common.sort': 'Sort',
  'common.view': 'View',
  'common.download': 'Download',
  'common.upload': 'Upload',
  'common.select': 'Select',
  'common.selectAll': 'Select All',
  'common.deselectAll': 'Deselect All',
  'common.clear': 'Clear',
  'common.reset': 'Reset',
  'common.apply': 'Apply',
  'common.ok': 'OK',
  'common.yes': 'Yes',
  'common.no': 'No',
  // Navigation
  'nav.home': 'HOME',
  'nav.howItWorks': 'HOW IT WORKS',
  'nav.forParents': 'FOR PARENTS',
  'nav.pricing': 'PRICING',
  'nav.login': 'Sign In',
  'nav.register': 'Sign Up',
  'nav.menu': 'Menu',

  // Hero
  'hero.badge': 'Smart Learning',
  'hero.title1': 'Learn by Solving',
  'hero.title2': 'Your Homework with',
  'hero.title3': 'Intelligent Help',
  'hero.description': 'Our AI guides children step by step without giving direct answers. They learn to think for themselves while receiving the support they need.',
  'hero.startFree': 'Start Free',
  'hero.meetTutors': 'Meet Your Tutors',
  'hero.viewDemo': 'View Demo',

  // Demo Page
  'demo.badge': 'Interactive Demo',
  'demo.title': 'Experience the Magic',
  'demo.subtitle': 'See how our AI guides the student step-by-step',
  'demo.assistant': 'AI Tutor',
  'demo.helpingWith': 'Helping with Math',
  'demo.startDemo': 'Start Demo',
  'demo.pause': 'Pause',
  'demo.readyTitle': 'Ready to Start?',
  'demo.readySubtitle': 'Watch an interactive simulation of how our AI helps without giving answers.',
  'demo.startNow': 'Start Now',
  'demo.provenMethodology': 'Proven Methodology',
  'demo.noDirectAnswers': 'No Direct Answers',
  'demo.messages': 'Messages',
  'demo.progress': 'Progress',
  'demo.badgeUnlocked': 'Badge Unlocked!',
  'demo.studentEarned': 'Student earned "Division Master"',
  'demo.watchAgain': 'Watch Again',
  'demo.startFree': 'Start Free Trial',
  'demo.features.guided.title': 'Guided Learning',
  'demo.features.guided.description': 'Conversational guidance that adapts to the student.',
  'demo.features.realLearning.title': 'Real Learning',
  'demo.features.realLearning.description': 'Students solve problems themselves.',
  'demo.features.achievements.title': 'Achievements',
  'demo.features.achievements.description': 'Gamified elements to keep them motivated.',
  'demo.cta.title': 'Ready to Try It?',
  'demo.cta.subtitle': 'Start your free trial today.',
  'demo.cta.startTrial': 'Start Free Trial',
  'demo.cta.viewPlans': 'View Plans',

  // Features
  'features.title': 'How Does TutorAI Kids Work?',
  'features.subtitle': 'A methodology designed for real learning',
  'features.guided.title': 'Guided Conversation',
  'features.guided.desc': 'AI interacts with questions that stimulate critical thinking and problem-solving.',
  'features.noAnswers.title': 'No Direct Answers',
  'features.noAnswers.desc': 'We never give the complete answer. We guide with hints and questions so they reach the solution themselves.',
  'features.dashboard.title': 'Parent Dashboard',
  'features.dashboard.desc': 'Detailed reports on progress, areas for improvement, and time dedicated to your children\'s studies.',
  'features.motivation.title': 'Constant Motivation',
  'features.motivation.desc': 'Achievement system, badges, and recognition that keep children motivated and engaged.',
  'features.viewDemo': 'View Interactive Demo',

  // Testimonials
  'testimonials.title': 'What Parents Say',
  'testimonials.subtitle': 'Families satisfied with their children\'s progress',
  'testimonials.parent1.name': 'Jennifer Smith',
  'testimonials.parent1.username': '@jennifers',
  'testimonials.parent1.text': 'My 10-year-old son has improved incredibly in math. Now he solves problems that seemed impossible before. The AI is very patient!',
  'testimonials.parent2.name': 'Jorge Ramírez',
  'testimonials.parent2.username': '@jramirez',
  'testimonials.parent2.text': 'As a busy parent, the dashboard lets me see exactly what my daughter is working on and where she needs more support. It\'s fantastic.',
  'testimonials.parent3.name': 'Sarah Johnson',
  'testimonials.parent3.username': '@sarahj',
  'testimonials.parent3.text': 'The best part is that it doesn\'t give him the answers. My son really learns to think for himself.',
  'testimonials.parent4.name': 'Carlos Sánchez',
  'testimonials.parent4.username': '@carloss',
  'testimonials.parent4.text': 'My 8-year-old twins are obsessed with earning badges. They\'ve turned homework into a fun game. The weekly reports are very detailed and useful.',
  'testimonials.parent5.name': 'Emily Davis',
  'testimonials.parent5.username': '@emilyd',
  'testimonials.parent5.text': 'The platform is intuitive and safe. I love being able to review the conversations and see how the AI guides my daughter without giving her the answers.',
  'testimonials.parent6.name': 'Roberto Flores',
  'testimonials.parent6.username': '@rflores',
  'testimonials.parent6.text': 'Excellent investment in my children\'s education. They have gained confidence and autonomy in their studies.',

  // Methodology
  'methodology.label': 'OUR METHODOLOGY',
  'methodology.title': 'Guided Learning,',
  'methodology.titleItalic': 'Real Results',
  'methodology.p1': 'At TutorAI Kids we believe that true learning happens when children discover solutions themselves. Our artificial intelligence is designed to ask the right questions at the right time.',
  'methodology.p2': 'Instead of providing direct answers, the AI analyzes the problem, identifies where the student is stuck, and offers strategic hints that guide them toward deep understanding of the concept.',
  'methodology.p3': 'Parents receive detailed reports that show not only what homework their child completed, but how they thought, what strategies they used and where they need additional reinforcement.',

  // Pricing
  'pricing.title': 'Plans for Every Family',
  'pricing.subtitle': 'Choose the plan that best fits your needs',
  'pricing.basic.title': 'Basic',
  'pricing.basic.price': '$29.99',
  'pricing.basic.period': '/month',
  'pricing.basic.feature1': '1 student',
  'pricing.basic.liveSessions': 'Up to 120 min/mo (4 sessions)',
  'pricing.basic.talkWith': 'Talk with Miss Ann!',
  'pricing.basic.feature2': 'AI tutoring and images',

  // ... (skip intermediate lines if possible, but allowMultiple might work)
  // Actually I need to do two separate replacements or one big block if they are close.
  // They are lines 125 and 136. close enough.

  'pricing.basic.feature3': 'Homework management',
  'pricing.basic.feature4': 'Educational games',
  'pricing.basic.feature5': 'Weekly reports',
  'pricing.basic.feature6': 'Email support',
  'pricing.basic.button': 'Start Now',
  'pricing.family.title': 'Family',
  'pricing.family.badge': 'MOST POPULAR',
  'pricing.family.price': '$59.99',
  'pricing.family.period': '/month',
  'pricing.family.liveSessions': 'Up to 90 min/week per student (3 sessions)',
  'pricing.family.talkWith': 'Talk with Miss Ann!',
  'pricing.family.feature1': 'Up to 3 students',
  'pricing.family.feature2': 'Unlimited AI tutoring (with images)',
  'pricing.family.feature3': 'Homework Management',
  'pricing.family.feature4': 'All educational games',
  'pricing.family.feature5': 'Detailed reports by subject',
  'pricing.family.feature6': 'Smart Study Plan with AI',
  'pricing.family.feature7': 'Practice Tests',
  'pricing.family.feature8': 'Family Connect',
  'pricing.family.feature9': 'Priority Support',
  'pricing.family.button': 'Start Now',
  'pricing.premium.title': 'Premium',
  'pricing.premium.price': 'Custom Pricing',
  'pricing.premium.period': '',
  'pricing.premium.feature1': 'Unlimited students',
  'pricing.premium.feature2': 'Everything in Family Plan',
  'pricing.premium.feature3': 'Email notifications',
  'pricing.premium.feature4': 'Custom reports',
  'pricing.premium.feature5': '24/7 priority support',
  'pricing.premium.feature6': 'Personalized tutor sessions',
  'pricing.premium.button': 'Contact Sales',
  'pricing.faq.title': 'Frequently Asked Questions',
  'pricing.faq.q1': 'Can I change my plan at any time?',
  'pricing.faq.a1': 'Yes, you can upgrade or change your plan at any time from your profile.',
  'pricing.faq.q2': 'What payment methods do you accept?',
  'pricing.faq.a2': 'We accept all major credit and debit cards through Stripe.',
  'pricing.faq.q3': 'Can I cancel my subscription?',
  'pricing.faq.a3': 'Yes, you can cancel your subscription at any time. You will continue to have access until the end of your billing period.',
  'pricing.faq.q4': 'Is there a free trial?',
  'pricing.faq.a4': 'Yes, we offer a 3‑day free trial for all new users. No credit card required.',

  // CTA
  'cta.title': 'Start Improving Your Children\'s Learning Today',
  'cta.subtitle': '3‑day free trial. No credit card required.',
  'cta.button': 'Create Free Account',

  // Footer
  'footer.description': 'Transforming education with artificial intelligence that guides without giving answers.',
  'footer.newsletter': 'NEWSLETTER',
  'footer.emailPlaceholder': 'Your email',
  'footer.privacyText': 'By subscribing you accept our',
  'footer.privacyLink': 'privacy policy',
  'footer.privacyPolicy': 'Privacy Policy',
  'footer.termsOfService': 'Terms of Service',
  'footer.accessibility': 'Accessibility',
  'footer.resources': 'RESOURCES',
  'footer.blog': 'Blog',
  'footer.guides': 'Parent Guides',
  'footer.faq': 'FAQ',
  'footer.followUs': 'FOLLOW US',
  'footer.copyright': 'All rights reserved.',

  // Login Page
  'login.title': 'Welcome Back',
  'login.subtitle': 'Sign in to view your children\'s progress',
  'login.email': 'Email Address',
  'login.password': 'Password',
  'login.rememberMe': 'Remember me',
  'login.forgotPassword': 'Forgot your password?',
  'login.signInButton': 'Sign In',
  'login.signingIn': 'Signing in...',
  'login.noAccount': 'Don\'t have an account?',
  'login.signUpLink': 'Sign up for free',
  'login.backToHome': 'Back to home',

  // Register Page
  'register.title': 'Create Your Account',
  'register.subtitle': 'Start improving your children\'s learning',
  'register.fullName': 'Full Name',
  'register.email': 'Email Address',
  'register.phone': 'Phone (Optional)',
  'register.password': 'Password',
  'register.confirmPassword': 'Confirm Password',
  'register.createButton': 'Create Account',
  'register.creating': 'Creating account...',
  'register.haveAccount': 'Already have an account?',
  'register.signInLink': 'Sign in',
  'register.backToHome': 'Back to home',
  'register.passwordMismatch': 'Passwords do not match',
  'register.passwordTooShort': 'Password must be at least 6 characters',
  'register.acceptTermsPrefix': 'I have read and agree to the',
  'register.termsOfServiceLink': 'Terms of Service',
  'register.acceptTermsAnd': 'and the',
  'register.privacyPolicyLink': 'Privacy Policy',
  'register.mustAcceptTerms': 'You must accept the Terms of Service and Privacy Policy to continue',
  'register.passwordHint': 'Minimum 8 characters, including letters and numbers',
  'confirmAccount.confirming': 'Confirming your account...',
  'confirmAccount.successTitle': 'Account confirmed!',
  'confirmAccount.successMessage': 'Your account is ready. Redirecting to your dashboard...',
  'confirmAccount.errorTitle': "We couldn't confirm your account",
  'confirmAccount.errorMessage': 'The link may have expired or already been used. Try signing in or registering again.',
  'confirmAccount.goToLogin': 'Go to sign in',
  'forgotPassword.title': 'Forgot Password',
  'forgotPassword.subtitle': "We'll send you a link to reset it",
  'forgotPassword.email': 'Email Address',
  'forgotPassword.sendButton': 'Send Link',
  'forgotPassword.sending': 'Sending...',
  'forgotPassword.successTitle': '📧 Check your email',
  'forgotPassword.successMessage': 'If an account exists for {{email}}, we sent a link to reset your password.',
  'forgotPassword.backToLogin': 'Back to sign in',
  'resetPassword.title': 'New Password',
  'resetPassword.subtitle': 'Choose a new password for your account',
  'resetPassword.newPassword': 'New Password',
  'resetPassword.confirmPassword': 'Confirm Password',
  'resetPassword.updateButton': 'Update Password',
  'resetPassword.updating': 'Updating...',
  'resetPassword.successTitle': '✅ Password updated!',
  'resetPassword.successMessage': 'You can now sign in with your new password.',
  'resetPassword.invalidLink': 'This link is invalid or has expired. Please request a new one.',
  'curiousAdventures.sectionTitle': '🎬 Curious Adventures',
  'curiousAdventures.sectionSubtitle': 'Short, fun chapters to learn something new',
  'curiousAdventures.viewAll': 'View all',
  'curiousAdventures.chapter': 'Chapter {{number}}',
  'curiousAdventures.comingSoon': 'Coming Soon',
  'curiousAdventures.availableOn': 'Available on {{date}}',
  'curiousAdventures.notReadyYet': "This chapter will be ready very soon! Try again in a bit.",
  'curiousAdventures.pageTitle': 'Curious Adventures',
  'curiousAdventures.pageSubtitle': 'All chapters, a new one every few days',
  'curiousAdventures.backToDashboard': 'Back to Dashboard',
  'curiousAdventures.close': 'Close',
  'register.successTitle': 'Account created successfully!',
  'register.successEmailTitle': '📧 Confirm your email',
  'register.successEmailBody': 'We sent an email to {{email}} with a link to confirm your account.',
  'register.successCheckSpam': '⚠️ Also check your spam folder if you don\'t see it',
  'register.successRedirecting': 'Redirecting to sign in...',

  // Dashboard Page
  'dashboard.title': 'Dashboard',
  'dashboard.subtitle': 'Manage your children\'s learning',
  'dashboard.welcome': 'Welcome',
  'dashboard.students': 'Students',
  'dashboard.totalSessions': 'Total Sessions',
  'dashboard.achievementsEarned': 'Achievements Earned',
  'dashboard.thisWeek': 'This Week',
  'dashboard.myStudents': 'My Students',
  'dashboard.addStudent': 'Add Student',
  'dashboard.noStudents': 'You haven\'t added any students yet',
  'dashboard.addFirstStudent': 'Add First Student',
  'dashboard.sessions': 'Sessions',
  'dashboard.achievements': 'Achievements',
  'dashboard.streak': 'Streak',
  'dashboard.viewDetails': 'View Details',
  'dashboard.startSession': 'Start Session',
  'dashboard.addStudentModal.title': 'Add Student',
  'dashboard.addStudentModal.studentName': 'Student Name',
  'dashboard.addStudentModal.age': 'Age',
  'dashboard.addStudentModal.grade': 'Grade',
  'dashboard.addStudentModal.selectGrade': 'Select a grade',
  'dashboard.addStudentModal.cancel': 'Cancel',
  'dashboard.addStudentModal.add': 'Add',
  'dashboard.addStudentModal.addButton': 'Add Student',
  'dashboard.addStudentModal.namePlaceholder': 'E.g.: Maria Garcia',
  'dashboard.addStudentModal.agePlaceholder': 'E.g.: 10',
  'dashboard.addStudentModal.mustBeLoggedIn': 'You must be logged in to add a student',
  'dashboard.addStudentModal.errorAdding': 'Error adding student',
  'dashboard.addStudentModal.saving': 'Saving...',
  'dashboard.addStudentModal.gradeOptions.preschool': 'Preschool',
  'dashboard.addStudentModal.gradeOptions.grade1': '1st Grade',
  'dashboard.addStudentModal.gradeOptions.grade2': '2nd Grade',
  'dashboard.addStudentModal.gradeOptions.grade3': '3rd Grade',
  'dashboard.addStudentModal.gradeOptions.grade4': '4th Grade',
  'dashboard.addStudentModal.gradeOptions.grade5': '5th Grade',
  'dashboard.addStudentModal.gradeOptions.grade6': '6th Grade',
  'dashboard.addStudentModal.gradeOptions.grade7': '7th Grade',
  'dashboard.addStudentModal.gradeOptions.grade8': '8th Grade',
  'dashboard.addStudentModal.gradeOptions.grade9': '9th Grade',
  'dashboard.addStudentModal.gradeOptions.grade10': '10th Grade',
  'dashboard.addStudentModal.gradeOptions.grade11': '11th Grade',
  'dashboard.addStudentModal.gradeOptions.grade12': '12th Grade',
  'dashboard.deleteConfirm': 'Are you sure you want to delete this student?',
  'dashboard.homework': 'Homework',
  'dashboard.logout': 'Sign Out',

  // Student
  'student.profile': 'Student Profile',
  'student.years': 'years',
  'student.startSession': 'Start Session',
  'student.progressBySubject': 'Progress by Subject',
  'student.recentActivity': 'Recent Activity',
  'student.noActivity': 'No recent activity',

  // Tutoring
  'tutoring.title': 'AI Tutoring',
  'tutoring.subtitle': 'Smart Educational Assistant',
  'tutoring.welcomeMessage': 'Hello {{name}}! 👋 I\'m your Tutor AI. I\'m here to help you learn and have fun together. What shall we study today?',

  // Homework
  'homework.title': 'Homework',
  'homework.management': 'Homework Management',
  'homework.manageDescription': 'Track and organize your children\'s assignments',
  'homework.newHomework': 'New Homework',
  'homework.back': 'Back',
  'homework.totalHomework': 'Total Homework',
  'homework.completed': 'Completed',
  'homework.pending': 'Pending',
  'homework.inProgress': 'In Progress',
  'homework.homework': 'Homework',
  'homework.student': 'Student',
  'homework.status': 'Status',
  'homework.actions': 'Actions',
  'homework.noHomework': 'No homework yet',
  'homework.noHomeworkForStudent': 'No homework yet for {{name}}',
  'homework.allStudents': 'All students',
  'homework.addFirstHomework': 'Add the first assignment to start tracking progress',
  'homework.homeworkTitle': 'Title',
  'homework.titlePlaceholder': 'e.g. Math pages 42-43',
  'homework.selectStudent': 'Select Student',
  'homework.cancel': 'Cancel',
  'homework.add': 'Add Homework',
  'homework.unassigned': 'Unassigned',
  'homework.loading': 'Loading homework...',
  'homework.confirmDelete': 'Are you sure you want to delete this homework?',
  'homework.completeAllFields': 'Please complete all fields',
  'homework.mustLogin': 'You must be logged in',
  'homework.errorAdding': 'Error adding homework',
  'homework.errorDeleting': 'Error deleting homework',

  // Games
  'games.title': 'Educational Games',
  'games.whyGames': 'Why Educational Games?',
  'games.whyGamesDescription': 'Our games are designed to make learning fun and effective, helping you master new skills while playing.',
  'games.new': 'NEW',
  'games.playNow': 'Play Now',
  'games.language': 'Language',
  'games.history': 'History',
  'games.geography': 'Geography',
  'games.biology': 'Biology',
  'games.math': 'Math',
  'games.preschool': 'Preschool',
  'games.prekTo1st': 'Pre-K to 1st Grade',
  'games.grades3to8': 'Grades 3-8',
  'games.grades3to6': 'Grades 3-6',
  'games.grades4to8': 'Grades 4-8',
  'games.grades1to8': 'Grades 1-8',

  // Game Titles & Descriptions
  'games.emojiZoo': 'Emoji Zoo',
  'games.emojiZooDescription': 'Learn about animals and their habitats in this interactive zoo adventure.',
  'games.timeMachine.title': 'Time Machine',
  'games.timeMachine.subtitle': 'Travel Through History',
  'games.geoMystery.title': 'Geo Mystery',
  'games.geoMystery.subtitle': 'Explore the World',
  'games.drIA.title': 'Dr. AI',
  'games.drIA.subtitle': 'Biology Explorer',
  'games.mathGames.title': 'Math Challenges',
  'games.mathGames.subtitle': 'Master the Numbers',

  // Secret Words
  'games.secretWords.errorGenerating': 'Error generating words. Please try again.',
  'common.changeLanguage': 'Change language',
  'guiasPadres.hero.title': 'How We Help Your Child Learn Better',
  'guiasPadres.hero.text': 'At TutorAI Kids, we don\'t just give answers. We guide children to discover solutions themselves, building confidence and critical thinking skills that last a lifetime.',
  'guiasPadres.teachingMethodTitle': 'Our Teaching Method',
  'guiasPadres.method1.title': 'Socratic Method: Learning Through Questions',
  'guiasPadres.method1.text': 'Instead of providing direct answers, Miss Ann asks thoughtful questions that guide your child to think critically. When your child asks \'What\'s the answer?\', Miss Ann responds with \'What do you think? Let\'s break it down together.\' This approach develops problem-solving skills and deep understanding.',
  'guiasPadres.method2.title': 'Personalized Learning Pace',
  'guiasPadres.method2.text': 'Every child learns differently. Our AI adapts to your child\'s unique learning speed, providing more support when needed and challenging them when they\'re ready. We track progress in real-time and adjust our teaching approach to maximize learning outcomes.',
  'guiasPadres.method3.title': 'Positive Reinforcement & Motivation',
  'guiasPadres.method3.text': 'We celebrate every small victory. When your child solves a problem, Miss Ann provides enthusiastic encouragement with emojis and positive feedback. Our achievement system with badges and rewards keeps children motivated and engaged in their learning journey.',
  'guiasPadres.keyFeaturesTitle': 'Key Features for Parents',
  'guiasPadres.feature1.title': 'Homework Guidance Without Cheating',
  'guiasPadres.feature1.text': 'Your child can upload homework images, and Miss Ann analyzes the questions. Instead of giving answers, she asks guiding questions like \'What information do we have?\' and \'What\'s the first step?\' This ensures your child truly understands the material.',
  'guiasPadres.feature2.title': 'Real-Time Parent Dashboard',
  'guiasPadres.feature2.text': 'Monitor your child\'s progress with detailed insights. See which subjects they\'re working on, how much time they spend learning, areas where they excel, and topics that need more attention. You\'ll receive weekly reports with actionable recommendations.',
  'guiasPadres.feature3.title': 'Educational Games That Teach',
  'guiasPadres.feature3.text': 'Learning doesn\'t have to be boring. Our interactive games cover math, language, science, and geography. Each game is designed by educators to reinforce curriculum concepts while keeping children entertained and engaged.',
  'guiasPadres.feature4.title': 'Safe & Secure Environment',
  'guiasPadres.feature4.text': 'Your child\'s safety is our priority. All conversations are monitored for appropriate content. We comply with child data protection regulations and never share personal information. Parents have full visibility into all interactions.',
  'guiasPadres.safety.title': 'What Miss Ann Does and Doesn\'t Do',
  'guiasPadres.safety.text': 'Miss Ann guides with questions, provides hints without direct answers, adapts to each student\'s pace, celebrates effort and progress, and identifies areas needing practice. However, Miss Ann never gives direct homework answers, never completes assignments for students, never replaces teachers or parents, and never stores personal data without consent.',
  'guiasPadres.whatParentsSayTitle': 'What Parents Say',
  'guiasPadres.testimonial1.name': 'Jennifer Smith',
  'guiasPadres.testimonial1.role': 'Mother of 2',
  'guiasPadres.testimonial1.quote': 'My son\'s math grades improved from C to A in just 3 months. Miss Ann\'s patient guidance helped him understand concepts he struggled with for years.',
  'guiasPadres.testimonial2.name': 'Michael Johnson',
  'guiasPadres.testimonial2.role': 'Father of 1',
  'guiasPadres.testimonial2.quote': 'The parent dashboard is incredible. I can see exactly what my daughter is working on and where she needs help. It\'s like having a tutor\'s report card every day.',
  'guiasPadres.testimonial3.name': 'Sarah Davis',
  'guiasPadres.testimonial3.role': 'Mother of 3',
  'guiasPadres.testimonial3.quote': 'My kids actually look forward to homework now! The games and achievement system turned learning into something fun. Best investment in their education.',
  'guiasPadres.finalCta.title': 'Ready to Transform Your Child\'s Learning?',
  'guiasPadres.finalCta.subtitle': 'Join thousands of parents who trust TutorIA Kids to guide their children to academic success.',
  'guiasPadres.finalCta.button': 'Start 3-Day Free Trial',
  'guiasPadres.finalCta.footnote': '✓ No credit card required  ✓ Cancel anytime  ✓ Full access to all features',
  'guiasPadres.footer.product': 'Product',
  'guiasPadres.footer.meetTutors': 'Meet Your Tutors',
  'guiasPadres.footer.company': 'Company',
  'guiasPadres.footer.aboutUs': 'About Us',
  'featureGate.verifyingPlan': 'Verifying plan...',
  'featureGate.familyExclusive': 'This advanced feature is exclusive to the Family Plan.',
  'featureGate.upgradeNow': 'Upgrade Now',
  'featureGate.subscriptionPaused': 'Your subscription is paused. Reactivate to regain access to this feature.',
  'featureGate.reactivate': 'Reactivate',
  'featureGate.subscriptionCancelled': 'Your subscription has been cancelled. Subscribe to a plan to access this feature.',
  'featureGate.subscribe': 'Subscribe',
  'featureGate.trialEnded': 'Your 3-day free trial has ended. Upgrade to the Family Plan to unlock this premium feature!',
  'featureGate.featureLocked': 'Feature Locked 🔒',
  'featureGate.familyBadge': 'Family',
  'featureGate.alreadyUpgraded': 'Already upgraded?',
  'featureGate.refresh': 'Refresh',
  'games.secretWords.title': 'Secret Words',
  'games.secretWords.subtitle': 'Guess the hidden word with AI hints',
  'games.secretWords.exit': 'Exit',
  'games.secretWords.score': 'Score',
  'games.secretWords.points': 'points',
  'games.secretWords.word': 'Word',
  'games.secretWords.attemptsRemaining': 'Attempts Remaining',
  'games.secretWords.generatingWords': 'Generating Words...',
  'games.secretWords.waitMessage': 'Preparing your challenge...',
  'games.secretWords.letters': 'letters',
  'games.secretWords.hint': 'Hint',
  'games.secretWords.visualHint': 'Visual Hint',
  'games.secretWords.needHelp': 'Need a hint?',
  'games.secretWords.viewFirstHint': 'View First Hint',
  'games.secretWords.viewSecondHint': 'View Second Hint',
  'games.secretWords.viewVisualHint': 'View Image',
  'games.secretWords.currentHint': 'Current Hint',
  'games.secretWords.correct': 'Correct!',
  'games.secretWords.oopsLost': 'Sorry!',
  'games.secretWords.wordWas': 'The word was',
  'games.secretWords.definition': 'Definition',
  'games.secretWords.nextWord': 'Next Word',
  'games.secretWords.finishGame': 'Finish Game',
  'games.secretWords.tryAgain': 'Try Again',
  'games.secretWords.skipWord': 'Skip Word',
  'games.secretWords.gameProgress': 'Game Progress',
  'games.secretWords.of': 'of',
  'games.secretWords.words': 'words',
  'games.secretWords.subjects.science': 'Science',
  'games.secretWords.subjects.math': 'Math',
  'games.secretWords.subjects.history': 'History',
  'games.secretWords.subjects.geography': 'Geography',
  'games.secretWords.subjects.language': 'Language',

  // Game Features
  'games.adaptiveAI': 'Adaptive AI',
  'games.adaptiveAIDescription': 'Adjusts difficulty automatically to match your pace.',
  'games.effectiveLearning': 'Effective Learning',
  'games.effectiveLearningDescription': 'Based on proven educational methodologies.',
  'games.progressTracking': 'Progress Tracking',
  'games.progressTrackingDescription': 'Monitor your achievements and growth over time.',

  // Emoji Zoo Game
  'games.zoo.title': 'Emoji Zoo',
  'games.zoo.subtitle': 'Discover the Animal World',
  'games.zoo.howToPlay': 'How to Play',
  'games.zoo.step1': 'Observe',
  'games.zoo.step1Desc': 'Look closely at the emoji shown.',
  'games.zoo.step2': 'Guess',
  'games.zoo.step2Desc': 'Choose the correct animal name.',
  'games.zoo.step3': 'Win',
  'games.zoo.step3Desc': 'Earn points and unlock new levels!',
  'games.zoo.selectDifficulty': 'Select Difficulty',
  'games.zoo.easy': 'Easy',
  'games.zoo.easyDesc': 'Common animals, no time limit.',
  'games.zoo.medium': 'Medium',
  'games.zoo.mediumDesc': 'Exotic animals, 30 seconds.',
  'games.zoo.hard': 'Hard',
  'games.zoo.hardDesc': 'Rare animals, 15 seconds.',
  'games.zoo.progress': 'Progress',
  'games.zoo.letter': 'Letter',
  'games.zoo.whatStartsWith': 'What starts with',
  'games.zoo.tapCorrect': 'Tap the correct animal!',
  'games.zoo.exit': 'Exit Game',
  'games.zoo.selected': 'Selected',
  'games.zoo.gameFinished': 'Game Finished!',
  'games.zoo.totalPoints': 'Total Points',
  'games.zoo.champion': 'Champion!',
  'games.zoo.playAgain': 'Play Again',
  'games.zoo.mainMenu': 'Main Menu',
  'games.zoo.correct': 'Correct!',
  'games.zoo.nextLetter': 'Next Letter',
  'games.zoo.viewResults': 'View Results',
  'games.zoo.almostThere': 'Almost there!',
  'games.zoo.correctAnswer': 'Correct answer:',
  'games.zoo.tryAgain': 'Try Again',
  'games.zoo.veryGood': 'Very Good!',

  // Parent Guide Page
  'parentGuide.title': 'Parent Guides',
  'parentGuide.subtitle': 'Everything you need to know about how AI supports your child\'s learning',
  'parentGuide.badge': 'For Parents',
  'parentGuide.quickNav.title': 'Quick Navigation',
  'parentGuide.quickNav.howItWorks': 'How It Works',
  'parentGuide.quickNav.methodology': 'Methodology',
  'parentGuide.quickNav.features': 'Features',
  'parentGuide.quickNav.faq': 'FAQ',
  'parentGuide.howItWorks.title': 'How Does it Work?',
  'parentGuide.howItWorks.subtitle': 'A simple process designed to support learning',
  'parentGuide.howItWorks.step1.title': 'Your Child Asks',
  'parentGuide.howItWorks.step1.description': 'Hi Tutor, I don\'t understand how to solve this fraction problem. Can you help me?',
  'parentGuide.howItWorks.step2.title': 'AI Guides',
  'parentGuide.howItWorks.step2.description': 'Our AI doesn\'t give direct answers. Instead, it asks guiding questions to help your child think and discover the solution on their own.',
  'parentGuide.howItWorks.step3.title': 'Your Child Learns',
  'parentGuide.howItWorks.step3.description': 'Through this process, your child develops critical thinking, problem-solving skills, and gains confidence in their abilities.',
  'parentGuide.methodology.title': 'Our Methodology',
  'parentGuide.methodology.subtitle': 'Based on proven pedagogical principles',
  'parentGuide.methodology.socratic.title': 'Socratic Method',
  'parentGuide.methodology.socratic.description': 'We use guiding questions instead of direct answers, promoting critical thinking and deep understanding.',
  'parentGuide.methodology.constructivism.title': 'Constructivism',
  'parentGuide.methodology.constructivism.description': 'Students build their own knowledge through active experience and reflection, not passive memorization.',
  'parentGuide.methodology.scaffolding.title': 'Scaffolding',
  'parentGuide.methodology.scaffolding.description': 'We provide progressive support that adapts to each student\'s level, gradually increasing independence.',
  'parentGuide.transparency.title': 'What AI Does and Doesn\'t Do',
  'parentGuide.transparency.subtitle': 'Total transparency about how we support learning',
  'parentGuide.transparency.does.title': 'What Tutor AI DOES',
  'parentGuide.transparency.does.item1': 'Asks guiding questions to stimulate thinking',
  'parentGuide.transparency.does.item2': 'Provides hints and clues without giving direct answers',
  'parentGuide.transparency.does.item3': 'Adapts to each student\'s learning pace',
  'parentGuide.transparency.does.item4': 'Celebrates effort and progress',
  'parentGuide.transparency.does.item5': 'Identifies areas that need more practice',
  'parentGuide.transparency.doesnt.title': 'What Tutor AI DOESN\'T DO',
  'parentGuide.transparency.doesnt.item1': 'Give direct answers to homework',
  'parentGuide.transparency.doesnt.item2': 'Complete assignments for students',
  'parentGuide.transparency.doesnt.item3': 'Replace the teacher or parent',
  'parentGuide.transparency.doesnt.item4': 'Make decisions about the child\'s education',
  'parentGuide.transparency.doesnt.item5': 'Store personal data without consent',
  'parentGuide.features.title': 'Key Features',
  'parentGuide.features.subtitle': 'Tools designed for parents and students',
  'parentGuide.features.dashboard.title': 'Parent Dashboard',
  'parentGuide.features.dashboard.description': 'Monitor your child\'s progress in real-time. See what subjects they\'re working on, their achievements, and areas that need more attention.',
  'parentGuide.features.games.title': 'Educational Games',
  'parentGuide.features.games.description': 'Learning through play. Interactive games that reinforce concepts in math, language, science, and more - all aligned with the curriculum.',
  'parentGuide.features.studyPlan.title': 'Smart Study Plan',
  'parentGuide.features.studyPlan.description': 'AI creates a personalized study plan based on your child\'s strengths and areas for improvement, adapting as they progress.',
  'parentGuide.gettingStarted.title': 'How to Get Started',
  'parentGuide.gettingStarted.subtitle': '4 simple steps to begin',
  'parentGuide.gettingStarted.step1.title': 'Create Account',
  'parentGuide.gettingStarted.step1.description': 'Sign up and create a profile for your child in less than 2 minutes.',
  'parentGuide.gettingStarted.step2.title': 'Set Preferences',
  'parentGuide.gettingStarted.step2.description': 'Select grade level, subjects of interest, and learning goals.',
  'parentGuide.gettingStarted.step3.title': 'Explore Together',
  'parentGuide.gettingStarted.step3.description': 'Spend the first few sessions with your child to familiarize them with the platform.',
  'parentGuide.gettingStarted.step4.title': 'Monitor Progress',
  'parentGuide.gettingStarted.step4.description': 'Check the dashboard regularly to see progress and celebrate achievements.',
  'parentGuide.faq.title': 'Frequently Asked Questions',
  'parentGuide.faq.q1.question': 'Is it safe for my child to use AI?',
  'parentGuide.faq.q1.answer': 'Yes, completely safe. TutorAI Kids is designed specifically for children, with content filters and constant supervision. We don\'t store personal conversations and comply with all child data protection regulations.',
  'parentGuide.faq.q2.question': 'Will AI do my child\'s homework?',
  'parentGuide.faq.q2.answer': 'No. Our AI is designed to guide, not to give direct answers. It uses the Socratic method, asking questions that help your child think and find solutions on their own.',
  'parentGuide.faq.q3.question': 'How much time should my child spend on the platform?',
  'parentGuide.faq.q3.answer': 'We recommend 20-30 minute sessions, 3-4 times per week. The platform includes reminders and time limits to promote healthy use.',
  'parentGuide.faq.q4.question': 'What if my child gets stuck?',
  'parentGuide.faq.q4.answer': 'The AI is designed to detect frustration and adjust its approach. If a student is really stuck, the system notifies you so you can provide additional support.',
  'parentGuide.faq.q5.question': 'Can I see what my child is doing?',
  'parentGuide.faq.q5.answer': 'Yes! The parent dashboard shows you all activities, progress, time spent, and areas where your child is excelling or needs more support.',
  'parentGuide.faq.q6.question': 'Does it replace the teacher?',
  'parentGuide.faq.q6.answer': 'Never. Our AI is a complementary tool that reinforces what is learned in school. We believe in the irreplaceable value of teachers and human interaction in education.',
  'parentGuide.cta.title': 'Ready to Support Your Child\'s Learning?',
  'parentGuide.cta.subtitle': 'Join thousands of parents who trust AI to enhance their children\'s education',
  'parentGuide.cta.trial': '3-day free trial • No credit card required',
  'parentGuide.cta.startTrial': 'Start Free Trial',
  'parentGuide.cta.viewDemo': 'View Demo',
  'parentGuide.cta.description': 'Join thousands of families already using TutorAI Kids to help their children achieve academic success.',
  'parentGuide.cta.button': 'Start Free Trial',
  'parentGuide.cta.features': 'Full access to all features • Cancel anytime • 24/7 support',

  'parentGuide.hero.title': 'Empower Your Child\'s Learning with AI',
  'parentGuide.hero.description': 'Discover how TutorAI Kids uses advanced artificial intelligence to help your child learn effectively, develop critical thinking, and reach their full academic potential.',
  'parentGuide.hero.cta': 'Start Free Trial',

  'parentGuide.socratic.title': 'The Socratic Method: Learning by Asking Questions',
  'parentGuide.socratic.description': 'Our AI tutor doesn\'t give direct answers. Instead, it guides your child through thoughtful questions that foster critical thinking and deep understanding. This proven method helps students develop problem-solving skills that last a lifetime.',
  'parentGuide.socratic.benefit1.title': 'Critical Thinking',
  'parentGuide.socratic.benefit1.description': 'Students learn to analyze problems and find solutions on their own',
  'parentGuide.socratic.benefit2.title': 'Deep Understanding',
  'parentGuide.socratic.benefit2.description': 'Guided questions help students understand concepts, not just memorize them',
  'parentGuide.socratic.benefit3.title': 'Confidence',
  'parentGuide.socratic.benefit3.description': 'Discovering answers on their own boosts self-esteem and motivation',

  'parentGuide.personalized.title': 'Personalized Learning for Every Child',
  'parentGuide.personalized.description': 'Every child learns differently. Our AI adapts to your child\'s unique pace, learning style, and level of understanding, providing personalized support that fits their needs.',
  'parentGuide.personalized.feature1.title': 'Adaptive Pace',
  'parentGuide.personalized.feature1.description': 'The AI adjusts difficulty based on your child\'s progress',
  'parentGuide.personalized.feature2.title': 'Multiple Learning Styles',
  'parentGuide.personalized.feature2.description': 'Supports visual, auditory, and hands-on learning',
  'parentGuide.personalized.feature3.title': 'Instant Feedback',
  'parentGuide.personalized.feature3.description': 'Immediate corrections and guidance to keep the momentum going',

  'parentGuide.motivation.title': 'A Motivation System That Works',
  'parentGuide.motivation.description': 'Keeping kids motivated is key to learning success. Our system of achievements, badges, and rewards makes learning fun and rewarding.',
  'parentGuide.motivation.element1.title': 'Unlockable Achievements',
  'parentGuide.motivation.element1.description': 'Students earn badges for completing challenges and reaching milestones',
  'parentGuide.motivation.element2.title': 'Progress Tracking',
  'parentGuide.motivation.element2.description': 'See their growth with engaging charts and stats',
  'parentGuide.motivation.element3.title': 'Celebrating Success',
  'parentGuide.motivation.element3.description': 'Every achievement is celebrated with animations and positive messages',

  'parentGuide.homework.title': 'Homework Help Without Cheating',
  'parentGuide.homework.description': 'Worried your child might just copy answers? Don\'t be. Our AI tutor is specifically designed to guide, not to give answers. Here\'s how it works:',
  'parentGuide.homework.step1.title': 'Upload a Photo',
  'parentGuide.homework.step1.description': 'Your child takes a photo of their homework',
  'parentGuide.homework.step2.title': 'AI Analyzes',
  'parentGuide.homework.step2.description': 'The tutor identifies the topic and difficulty level',
  'parentGuide.homework.step3.title': 'Guided Questions',
  'parentGuide.homework.step3.description': 'The AI asks questions that lead your child to the answer',
  'parentGuide.homework.step4.title': 'Learning by Doing',
  'parentGuide.homework.step4.description': 'Your child discovers the solution on their own',

  'parentGuide.parentDashboard.title': 'Parent Dashboard: Stay Informed',
  'parentGuide.parentDashboard.description': 'Track your child\'s progress, review tutoring sessions, and celebrate achievements, all from your personalized dashboard.',
  'parentGuide.parentDashboard.feature1.title': 'Real-Time Tracking',
  'parentGuide.parentDashboard.feature1.description': 'See what your child is studying and how much time they spend',
  'parentGuide.parentDashboard.feature2.title': 'Progress Reports',
  'parentGuide.parentDashboard.feature2.description': 'Detailed reports on strengths and areas for improvement',
  'parentGuide.parentDashboard.feature3.title': 'Session History',
  'parentGuide.parentDashboard.feature3.description': 'Review past conversations and topics covered',
  'parentGuide.parentDashboard.feature4.title': 'Notifications',
  'parentGuide.parentDashboard.feature4.description': 'Get alerts about achievements and important milestones',

  'parentGuide.educationalGames.title': 'Educational Games That Teach',
  'parentGuide.educationalGames.description': 'Learning doesn\'t have to be boring. Our educational games make practicing math, science, history, and more fun and engaging.',
  'parentGuide.educationalGames.game1.title': 'Time Machine',
  'parentGuide.educationalGames.game1.description': 'Travel through history and chat with historical figures',
  'parentGuide.educationalGames.game2.title': 'Secret Words',
  'parentGuide.educationalGames.game2.description': 'Build vocabulary with AI-powered word challenges',
  'parentGuide.educationalGames.game3.title': 'Geo Mystery',
  'parentGuide.educationalGames.game3.description': 'Explore geography by solving location mysteries',
  'parentGuide.educationalGames.game4.title': 'Dr. AI',
  'parentGuide.educationalGames.game4.description': 'Learn biology by diagnosing virtual medical cases',
  'parentGuide.educationalGames.game5.title': 'Math Challenges',
  'parentGuide.educationalGames.game5.description': 'Master math with fun, interactive games',
  'parentGuide.educationalGames.game6.title': 'Emoji Zoo',
  'parentGuide.educationalGames.game6.description': 'Learn about animals in a fun and creative way',

  'parentGuide.safety.title': 'Safety and Privacy First',
  'parentGuide.safety.description': 'Your child\'s safety is our top priority. Here\'s how we protect your family:',
  'parentGuide.safety.measure1.title': 'Filtered Content',
  'parentGuide.safety.measure1.description': 'All AI is trained to provide only age-appropriate content',
  'parentGuide.safety.measure2.title': 'No Ads',
  'parentGuide.safety.measure2.description': 'A 100% ad-free learning environment',
  'parentGuide.safety.measure3.title': 'Encrypted Data',
  'parentGuide.safety.measure3.description': 'All student information is encrypted and secure',
  'parentGuide.safety.measure4.title': 'Parental Control',
  'parentGuide.safety.measure4.description': 'Parents have full access to and control over their children\'s accounts',

  'parentGuide.testimonials.title': 'What Other Parents Say',
  'parentGuide.testimonial1.text': 'TutorAI Kids has transformed the way my daughter approaches homework. She\'s no longer struggling alone, she has a patient tutor available 24/7. Her grades have improved and she genuinely enjoys learning now.',
  'parentGuide.testimonial1.author': 'Sarah M.',
  'parentGuide.testimonial1.role': 'Mother of a 5th grade student',
  'parentGuide.testimonial2.text': 'As a busy parent, I can\'t always help with homework. TutorAI Kids fills that gap perfectly. I love that it doesn\'t just give answers, it teaches my son to think critically.',
  'parentGuide.testimonial2.author': 'Michael R.',
  'parentGuide.testimonial2.role': 'Father of a 3rd grade student',
  'parentGuide.testimonial3.text': 'The educational games are amazing! My son thinks he\'s just playing, but he\'s actually learning. The dashboard lets me see his progress and celebrate his achievements together.',
  'parentGuide.testimonial3.author': 'Jennifer L.',
  'parentGuide.testimonial3.role': 'Mother of a 2nd grade student',

  // Privacy Policy
  'privacy.coppaCompliant': 'COPPA Compliant',
  'privacy.title': 'Privacy Policy',
  'privacy.subtitle': 'We take your privacy and your children\'s safety very seriously.',
  'privacy.lastUpdated': 'Last updated',
  'privacy.coppaBadgeTitle': 'COPPA Certified',
  'privacy.coppaBadgeText': 'We strictly adhere to the Children\'s Online Privacy Protection Act (COPPA) to ensure a safe environment for your children.',
  'privacy.keyRequirements': 'Key Requirements',
  'privacy.requirement1Title': 'Clear Privacy Policy',
  'privacy.requirement1Text': 'We maintain a clear and accessible privacy policy describing our information practices.',
  'privacy.requirement2Title': 'Verifiable Parental Consent',
  'privacy.requirement2Text': 'We require verifiable parental consent before collecting any personal information from children.',
  'privacy.requirement2Item1': 'Credit card verification',
  'privacy.requirement2Item2': 'Email confirmation',
  'privacy.requirement2Item3': 'Signed consent form',
  'privacy.requirement2Item4': 'Government ID check (optional)',
  'privacy.requirement3Title': 'Notice to Parents',
  'privacy.requirement3Text': 'We provide direct notice to parents about our information practices regarding children.',
  'privacy.requirement4Title': 'Data Minimization',
  'privacy.requirement4Text': 'We only collect reasonably necessary information for the child to participate in the activity.',
  'privacy.requirement5Title': 'Parental Rights',
  'privacy.requirement5Text': 'Parents have full control over their child\'s data.',
  'privacy.requirement5Item1': 'Review personal information',
  'privacy.requirement5Item2': 'Request deletion',
  'privacy.requirement5Item3': 'Revoke consent',
  'privacy.requirement5Item4': 'Prevent further collection',
  'privacy.requirement6Title': 'Data Retention',
  'privacy.requirement6Text': 'We retain information only as long as necessary to fulfill the purpose for which it was collected.',
  'privacy.whoNeedsTitle': 'Who Needs to Comply?',
  'privacy.whoNeedsText1': 'Operators of commercial websites and online services directed to children under 13.',
  'privacy.whoNeedsText2': 'We fully comply with these regulations.',
  'privacy.dataCollectionTitle': 'What Data We Collect',
  'privacy.parentInfoTitle': 'Parent Information',
  'privacy.parentInfo1': 'Name and Email',
  'privacy.parentInfo2': 'Payment Information',
  'privacy.parentInfo3': 'Contact Details',
  'privacy.childInfoTitle': 'Child Information',
  'privacy.childInfo1': 'First Name (or Nickname)',
  'privacy.childInfo2': 'Age/Grade Level',
  'privacy.childInfo3': 'Learning Preferences',
  'privacy.childInfo4': 'Academic Progress',
  'privacy.childInfo5': 'Chat Interactions (for tutoring)',
  'privacy.notCollectedTitle': 'What We DO NOT Collect',
  'privacy.notCollected1': 'Full Physical Address',
  'privacy.notCollected2': 'Phone Number',
  'privacy.notCollected3': 'Photos or Videos',
  'privacy.notCollected4': 'Social Media Links',
  'privacy.notCollected5': 'Biometric Data',
  'privacy.protectionTitle': 'How We Protect Data',
  'privacy.protection1Title': 'Encryption',
  'privacy.protection1Text': 'All data is encrypted in transit and at rest using industry standards.',
  'privacy.protection2Title': 'Access Control',
  'privacy.protection2Text': 'Strict access controls ensure only authorized personnel can access data.',
  'privacy.protection3Title': 'Monitoring',
  'privacy.protection3Text': 'Continuous monitoring for security threats and vulnerabilities.',
  'privacy.protection4Title': 'Data Deletion',
  'privacy.protection4Text': 'Secure deletion processes when data is no longer needed.',
  'privacy.aiSafetyTitle': 'AI Safety & Data Integrity',
  'privacy.aiSafety1Title': 'No AI Training',
  'privacy.aiSafety1Text': 'Student data is NEVER used to train public AI models.',
  'privacy.aiSafety2Title': 'No Data Selling',
  'privacy.aiSafety2Text': 'We never sell your child\'s personal information to third parties nor use it for behavioral advertising.',
  'privacy.aiSafety3Title': 'Trusted Providers',
  'privacy.aiSafety3Text': 'We share strictly necessary data with trusted providers (e.g., Stripe for payments, Google Gemini for educational AI) solely for service delivery, under strict confidentiality agreements.',
  'privacy.aiSafety4Title': 'Security & Encryption',
  'privacy.aiSafety4Text': 'All data is encrypted in transit (SSL/TLS) and at rest. Only authorized personnel have access to sensitive information, with strict access controls and regular audits.',
  'privacy.dataRetentionTitle': 'Data Retention Policy',
  'privacy.dataRetentionText': 'Personal data is retained only as long as necessary to provide our educational services. Academic session data is kept for progress tracking while the account is active. Parents can request complete data deletion at any time, and it will be removed within 30 days, except where legally required to retain it.',
  'privacy.parentalRightsTitle': 'Your Rights as a Parent',
  'privacy.parentalRightsText': 'You have complete control over your child\'s account and data.',
  'privacy.right1Title': 'Access',
  'privacy.right1Text': 'Review any information collected.',
  'privacy.right2Title': 'Correction',
  'privacy.right2Text': 'Update or correct inaccuracies.',
  'privacy.right3Title': 'Deletion',
  'privacy.right3Text': 'Delete your child\'s account and data.',
  'privacy.operatorTitle': 'Operator Information',
  'privacy.operatorAddress': '3007 Rosebud Lane, Brandon, FL 33511, United States',
  'privacy.operatorText': 'This service is operated by Neo AI Estudio. For privacy inquiries, please contact privacy@tutoraikids.com. For general support, contact support@tutoraikids.com.',
  'privacy.right4Title': 'Control',
  'privacy.right4Text': 'Manage consent settings anytime.',
  'privacy.contactTitle': 'Contact Us',
  'privacy.contactText': 'If you have any questions about our privacy practices, please contact us.',
  'privacy.contactEmail': 'Email',
  'privacy.contactResponseTime': 'Response Time',
  'privacy.contactResponseValue': 'Within 24 hours',
  'privacy.contactOfficer': 'Privacy Officer',
  'privacy.contactOfficerValue': 'Robert Smith',
  'privacy.updatesTitle': 'Updates to Policy',
  'privacy.updatesText': 'We may update this privacy policy from time to time. We will notify you of any significant changes.',
  'privacy.ctaButton': 'Create Free Account',
  'privacy.ctaText': 'Join thousands of parents who trust us.',
  'privacy.footerDescription': 'Safe AI tutoring for kids.',
  'privacy.footerPrivacy': 'Privacy Policy',
  'privacy.footerTerms': 'Terms of Service',
  'privacy.footerHome': 'Home',
  'privacy.footerCopyright': 'All rights reserved. TutorAI Kids is a trademark of Neo AI Estudio.',

  // Terms of Service
  'terms.title': 'Terms of Service',
  'terms.subtitle': 'Please read these terms carefully before using our services.',
  'terms.lastUpdated': 'Last updated',
  'terms.badge': 'Legal Agreement',
  'terms.intro': 'By accessing or using TutorAI Kids, a product of Neo AI Estudio, you agree to be bound by these Terms of Service and our Privacy Policy.',
  'terms.section1.title': '1. Acceptance of Terms',
  'terms.section1.text': 'By accessing and using our platform, you accept and agree to be bound by the terms and provision of this agreement. If you do not agree to abide by these terms, please do not use this service.',
  'terms.section2.title': '2. Description of Service',
  'terms.section2.text': 'TutorAI Kids provides an AI-powered educational platform for children. We reserve the right to modify, suspend, or discontinue the service at any time without notice.',
  'terms.section3.title': '3. User Accounts',
  'terms.section3.text': 'You are responsible for maintaining the confidentiality of your account and password. You agree to accept responsibility for all activities that occur under your account or password.',
  'terms.section4.title': '4. User Conduct',
  'terms.section4.text': 'You agree not to use the service for any unlawful purpose or in any way that interrupts, damages, or impairs the service. Harassment, abuse, or any inappropriate behavior towards the AI or other users is strictly prohibited.',
  'terms.section5.title': '5. Intellectual Property',
  'terms.section5.text': 'All content included on this site, such as text, graphics, logos, images, and software, is the property of TutorAI Kids or its content suppliers and protected by international copyright laws.',
  'terms.section6.title': '6. Termination',
  'terms.section6.text': 'We may terminate or suspend access to our service immediately, without prior notice or liability, for any reason whatsoever, including without limitation if you breach the Terms.',
  'terms.section7.title': '7. Limitation of Liability',
  'terms.section7.text': 'In no event shall Neo AI Estudio, its product TutorAI Kids, nor its directors, employees, partners, agents, suppliers, or affiliates, be liable for any indirect, incidental, special, consequential or punitive damages. We do not guarantee specific academic outcomes, test scores, or educational results from using our AI tutoring services.',
  'terms.section8.title': '8. Parental Responsibility & Age Requirements',
  'terms.section8.text': 'TutorAI Kids is designed for children under 13 years of age. Accounts must be created and managed by a parent or legal guardian aged 18 or older. By creating an account, you confirm that you are the parent or legal guardian and accept full responsibility for all activities under your account. Children may not create accounts independently.',
  'terms.section8.coppaText': "By creating an account and enrolling your child, you provide verifiable parental consent, as required by the Children's Online Privacy Protection Act (COPPA), for the collection and use of your child's information necessary to provide the service. You may review, correct, or request deletion of that information at any time. Full details on what data we collect, how we use it, and how we protect it are in our",
  'terms.section9.title': '9. AI Technology & Disclaimers',
  'terms.section9.text': 'TutorAI Kids uses advanced artificial intelligence technology (including Google Gemini) to provide educational tutoring. You acknowledge that AI is a developing technology and may generate inaccurate, incomplete, or inappropriate content. The AI-generated content is provided "as is" without warranties of any kind. TutorAI Kids is not a substitute for professional educational advice or human tutors. Parents should supervise their child\'s interactions with the AI.',
  'terms.section10.title': '10. Acceptable Use of AI',
  'terms.section10.text': 'You agree to use the AI technology solely for educational purposes. Prohibited activities include: attempting to "jailbreak" or manipulate the AI to generate inappropriate content, using the service for non-educational purposes, sharing account access with unauthorized parties, or attempting to reverse-engineer our AI systems. Violations may result in immediate account suspension.',
  'terms.section11.title': '11. Content Ownership & Licensing',
  'terms.section11.text': 'You retain ownership of all content you input into TutorAI Kids (questions, homework uploads, etc.). AI-generated content (tutoring responses, study materials) remains the property of TutorAI Kids, but we grant you a personal, non-commercial license to use it for educational purposes. You may not sell, distribute, or commercially exploit AI-generated content without our written permission.',
  'terms.section12.title': '12. Payments, Subscriptions & Refunds',
  'terms.section12.text': 'Subscriptions automatically renew at the end of each billing period unless canceled. You may cancel anytime through your account settings, effective at the end of the current billing period. Refunds are available within 7 days of initial purchase, prorated for any usage. We use Stripe to process payments securely; we do not store credit card information. Subscription prices are subject to change with 30 days notice. All prices are shown in US Dollars (USD) and represent the total amount charged; we do not currently add taxes (such as sales tax) separately at checkout. If this changes in the future, any applicable tax will be clearly shown before you confirm your payment.',
  'terms.section13.title': '13. Dispute Resolution & Governing Law',
  'terms.section13.text': 'These Terms are governed by the laws of the State of Florida, United States. Any disputes arising from these Terms or your use of TutorAI Kids (a product of Neo AI Estudio) shall be resolved through binding arbitration, except where prohibited by law. You waive the right to participate in class action lawsuits. For any legal matters, please contact us at legal@tutoraikids.com before initiating formal proceedings.',
  'terms.section14.title': '14. Changes to These Terms',
  'terms.section14.text': 'We may update these Terms of Service from time to time. If we make significant changes, we will notify you through a visible notice on the platform or by email before the changes take effect. The "last updated" date at the top of this page always reflects the current version. Continued use of the platform after a change takes effect constitutes your acceptance of the updated terms.',
  'terms.contact.title': 'Contact Us',
  'terms.contact.text': 'If you have any questions about these Terms, please contact us.',
  'terms.contact.email': 'support@tutoraikids.com',
  'terms.contact.address': 'Neo AI Estudio, 3007 Rosebud Lane, Brandon, FL 33511, United States',

  // Accessibility
  'accessibility.badge': 'Accessibility Commitment',
  'accessibility.title': 'Accessibility Statement',
  'accessibility.subtitle': 'We want TutorIA Kids to be usable by every family, including children and parents with disabilities.',
  'accessibility.lastUpdated': 'Last updated',
  'accessibility.intro': 'At Neo AI Estudio we believe AI-assisted education should be within reach of every child, regardless of ability. This page describes our commitment to accessibility, what we have implemented so far, and how to report an issue to us.',
  'accessibility.section1.title': '1. Our Commitment',
  'accessibility.section1.text': 'We work continuously to make TutorIA Kids perceivable, operable, understandable, and robust for as many users as possible, including people who use assistive technology such as screen readers, keyboard navigation, or text-magnification software.',
  'accessibility.section2.title': '2. Standard We Follow',
  'accessibility.section2.text': 'We use the Web Content Accessibility Guidelines (WCAG) 2.1, Level AA, as our reference for designing and building the platform. This is a goal we actively work toward, not a formal certification we already hold.',
  'accessibility.section3.title': '3. Measures We Have Implemented',
  'accessibility.section3.item1': 'Semantic HTML structure (real headings, buttons, and links instead of generic elements)',
  'accessibility.section3.item2': 'Alternative text on meaningful icons and images',
  'accessibility.section3.item3': 'Working keyboard navigation across forms and main flows',
  'accessibility.section3.item4': 'Color contrast chosen to make reading easier, including for children',
  'accessibility.section3.item5': 'Full language switching between Spanish and English across the whole app',
  'accessibility.section3.item6': 'Clear typography and readable text sizes, with a layout that adapts to phone, tablet, and desktop',
  'accessibility.section4.title': '4. Known Limitations',
  'accessibility.section4.text': "Some parts of the platform do not yet fully meet WCAG 2.1 AA: certain drag-and-drop mini-games can be hard to use with only a keyboard or screen reader, and some third-party components (like the checkout flow and the live voice session) have their own accessibility level that we don't directly control. We continue working to improve these areas.",
  'accessibility.section5.title': '5. Compatible Technology',
  'accessibility.section5.text': 'TutorIA Kids is designed to work on recent versions of the most common browsers (Chrome, Safari, Edge, and Firefox) on phone, tablet, and desktop. While we have not exhaustively tested every screen-reader and browser combination, we follow standard semantic HTML practices to maximize compatibility.',
  'accessibility.section6.title': '6. How to Report an Issue',
  'accessibility.section6.text': 'If you run into an accessibility barrier while using TutorIA Kids, or have a suggestion, please write to us. We take every report seriously and work to resolve it as soon as possible.',
  'accessibility.contact.title': 'Found an accessibility barrier?',
  'accessibility.contact.text': 'Tell us what you found and on which page, so we can review it and make it better.',

  // FAQ Page
  'faqPage.title': 'Frequently Asked Questions',
  'faqPage.subtitle': 'Find answers to common questions about TutorAI Kids',
  'faqPage.searchPlaceholder': 'Search questions...',
  'faqPage.categories.all': 'All',
  'faqPage.categories.general': 'General',
  'faqPage.categories.methodology': 'Methodology',
  'faqPage.categories.pricing': 'Pricing',
  'faqPage.categories.safety': 'Safety',
  'faqPage.categories.technical': 'Technical',
  'faqPage.cta.title': 'Still have questions?',
  'faqPage.cta.text': 'Our support team is here to help you.',
  'faqPage.cta.button': 'Contact Support',

  // FAQ Items - General
  'faqPage.q.general.1': 'What is TutorAI Kids?',
  'faqPage.a.general.1': 'TutorAI Kids is an intelligent educational platform designed for children aged 5-12. It uses AI to guide students through their homework and learning process without giving direct answers, promoting critical thinking.',
  'faqPage.q.general.2': 'What age range is it for?',
  'faqPage.a.general.2': 'Our platform is optimized for elementary and middle school students, typically ages 5 to 12. The content and interface adapt to the child\'s grade level.',
  'faqPage.q.general.3': 'Is it available in other languages?',
  'faqPage.a.general.3': 'Yes, TutorAI Kids is fully bilingual (English and Spanish). You can switch languages at any time from the settings.',

  // FAQ Items - Methodology
  'faqPage.q.methodology.1': 'Does the AI do the homework for my child?',
  'faqPage.a.methodology.1': 'No. This is a core principle of our platform. Our AI uses the Socratic method: it asks guiding questions and provides hints to help your child discover the answer themselves, but never provides the direct solution.',
  'faqPage.q.methodology.2': 'How does the AI know what my child is studying?',
  'faqPage.a.methodology.2': 'Students can upload photos of their homework or textbooks. Our AI analyzes the image, understands the context, and starts a guided tutoring session based on that specific material.',

  // FAQ Items - Pricing
  'faqPage.q.pricing.1': 'How does the free trial work?',
  'faqPage.a.pricing.1': 'We offer a 3-day full-access free trial. You don\'t need to enter a credit card to start. After 3 days, you can choose a subscription plan to continue.',
  'faqPage.q.pricing.2': 'Can I cancel anytime?',
  'faqPage.a.pricing.2': 'Yes, absolutely. There are no long-term contracts. You can cancel your subscription instantly from your dashboard profile.',
  'faqPage.q.pricing.3': 'Do you offer family plans?',
  'faqPage.a.pricing.3': 'Yes! Our Family Plan ($59.99/mo) covers up to 3 students, making it perfect for siblings.',

  // FAQ Items - Safety
  'faqPage.q.safety.1': 'Is it safe for children?',
  'faqPage.a.safety.1': 'Safety is our top priority. Our AI is filtered to be strictly educational and age-appropriate. We are COPPA compliant and do not sell data.',
  'faqPage.q.safety.2': 'Are there ads?',
  'faqPage.a.safety.2': 'No. TutorAI Kids is a completely ad-free environment to ensure your child remains focused on learning.',

  // FAQ Items - Technical
  'faqPage.q.technical.1': 'What devices can I use?',
  'faqPage.a.technical.1': 'TutorAI Kids works on any device with a web browser: computers (Windows/Mac), tablets (iPad/Android), and smartphones.',
  'faqPage.q.technical.2': 'Can I use it offline?',
  'faqPage.a.technical.2': 'An internet connection is required to interact with the AI tutor and load the educational games.',

  // Support Widget
  'support.welcome': '👋 Hi! I\'m TutorAI Support. How can I help you today?',
  'support.title': 'TutorAI Support',
  'support.subtitle': 'We typically reply instantly',
  'support.placeholder': 'Ask for help...',
  'support.error': 'Sorry, I\'m having trouble connecting right now.',
  'support.connectionError': 'I\'m having a little trouble connecting. Please check your internet. 🔌',

  // Cookies
  'cookies.title': 'We use cookies!',
  'cookies.description': 'We use cookies to enhance your experience, analyze our platform usage, and show you content you\'ll love.',
  'cookies.accept': 'Accept all',
  'cookies.decline': 'Only necessary',
  'cookies.moreInfo': 'More information',

  // Kids Dashboard Page
  'kidsDashboard.loadingAdventure': 'Loading your adventure...',
  'kidsDashboard.noStudentFound': 'No Student Found',
  'kidsDashboard.noStudentMessage': 'Ask your parent to add you as a student first!',
  'kidsDashboard.goToParentDashboard': 'Go to Parent Dashboard',
  'kidsDashboard.dailyStreak': 'Daily Streak',
  'kidsDashboard.days': '{{count}} Days',
  'kidsDashboard.currentLevel': 'Current Level',
  'kidsDashboard.level': 'Level {{level}}',
  'kidsDashboard.welcomeBack': 'Welcome Back, {{name}}! 👋',
  'kidsDashboard.readyForAdventure': 'Ready for your next adventure?',
  'kidsDashboard.xpProgress': '{{xp}} / 500 XP',
  'kidsDashboard.xpToNextLevel': '{{xp}} XP to next level!',
  'kidsDashboard.continueAdventure': 'Continue Your Adventure',
  'kidsDashboard.continueAdventureSubtitle': 'Jump back into learning and earn more rewards!',
  'kidsDashboard.startNextMission': 'Start Next Mission',
  'kidsDashboard.questIslands': 'Your Quest Islands',
  'kidsDashboard.levelExplorer': 'Level {{level}} Explorer',
  'kidsDashboard.xp': 'XP',
  'kidsDashboard.pointsToNextLevel': '{{points}} points to next level',
  'kidsDashboard.myBadges': 'My Badges',
  'kidsDashboard.locked': '🔒 Locked',
  'kidsDashboard.playGames': 'Play Games',
  'kidsDashboard.miniMissAnnTitle': 'Talk with Mini Miss Ann! 🎀',
  'kidsDashboard.miniMissAnnSubtitle': 'Practice letters, numbers, and more, just by talking!',

  // Chat Page
  'chat.confirmEndSession': 'Are you sure you want to finish this session?',
  'chat.errorSavingSession': 'Error saving session: {{message}}',
  'chat.fileTooLarge': 'File too large (Max 5MB)',
  'chat.voiceNotSupported': 'Voice input not supported.',
  'chat.micPermissionDenied': 'We need microphone access to hear you. Please allow it in your browser settings.',
  'chat.voiceRecognitionError': 'We couldn\'t hear that clearly. Please try again or type your message.',
  'chat.couldNotStartSession': 'Could not start a chat session. Please check your limits or connection.',
  'chat.backToDashboard': 'Back to Dashboard',
  'chat.online': 'Online',
  'chat.endSession': 'End Session',
  'chat.end': 'End',
  'chat.greeting': 'Hi {{name}}! 👋',
  'chat.introPrefix': 'I\'m',
  'chat.introQuestion': 'What homework or question shall we tackle today?',
  'chat.sentImage': '📸 Sent an image',
  'chat.imageAttached': 'Image attached',
  'chat.uploadHomeworkPhoto': 'Upload Homework Photo',
  'chat.inputPlaceholder': 'Type or use mic...',
  'chat.stopListening': 'Stop Listening',
  'chat.startVoiceInput': 'Start Voice Input',
  'chat.aiDisclaimer': 'AI can make mistakes. Check important info.',
  'chat.limitReachedTitle': 'Limit Reached!',
  'chat.limitReachedMessage': 'You\'ve completed all your available sessions for this period. Your child is learning so much! ✨',
  'chat.upgradePlan': 'Upgrade My Plan',
  'chat.altAi': 'AI',
  'chat.altUserUpload': 'User Upload',
  'chat.altTyping': 'Typing',
  'chat.altPreview': 'Preview',

  // Agent Selection Page
  'agentSelection.title': 'Meet Your Tutors! 🚀',
  'agentSelection.subtitle': 'Choose a specialized AI tutor to help you with your homework today. They all have different super-powers!',
  'agentSelection.startChat': 'Start Chat',

  // Notification Center
  'notifications.title': 'Notifications',
  'notifications.markAllRead': 'Mark all as read',
  'notifications.empty': 'You have no notifications',
  'notifications.deleteTooltip': 'Delete notification',
  'notifications.achievementUnlocked': 'New achievement unlocked!',
  'notifications.timeAgo.now': 'Just now',
  'notifications.timeAgo.minutes': '{{count}} min ago',
  'notifications.timeAgo.hours': '{{count}} h ago',
  'notifications.timeAgo.days': '{{count}} days ago',
  'notifications.toastTitle': '🎉 Achievement Unlocked!',
  'notifications.toastSubtitle': 'Check your notifications',

  // Dashboard Page - Quick Access & Edit Student Modal (i18n coverage batch 2)
  'dashboard.loadingDashboard': 'Loading dashboard...',
  'dashboard.studentLimitReached': 'You have reached the limit of {{limit}} students for your plan. Please upgrade to add more.',
  'dashboard.quickAccess.kidsDashboard': 'Kids Dashboard',
  'dashboard.quickAccess.profile': 'Profile',
  'dashboard.quickAccess.calendar': 'Calendar',

  // Calendar (/calendario) -- see matching comment in es/common.ts.
  'calendar.pageTitle': 'Calendar',
  'calendar.weekdays.sunday': 'Sunday',
  'calendar.weekdays.monday': 'Monday',
  'calendar.weekdays.tuesday': 'Tuesday',
  'calendar.weekdays.wednesday': 'Wednesday',
  'calendar.weekdays.thursday': 'Thursday',
  'calendar.weekdays.friday': 'Friday',
  'calendar.weekdays.saturday': 'Saturday',
  'calendar.loading': 'Loading calendar...',
  'calendar.noSessions': 'No sessions scheduled for this day',
  'calendar.mustLogin': 'You must be logged in',
  'calendar.errorGettingStudent': 'Could not determine the student',
  'calendar.sessionAdded': 'Session added successfully',
  'calendar.sessionAddedWithEmail': 'Session added successfully. An email notification was sent.',
  'calendar.errorAdding': 'Error adding the session',
  'calendar.confirmDelete': 'Are you sure you want to delete this session?',
  'calendar.sessionDeleted': 'Session deleted',
  'calendar.errorDeleting': 'Error deleting the session',
  'calendar.completed': 'Completed',
  'calendar.sessionsFor': 'Sessions for {{date}}',
  'calendar.addSession': 'Add Session',
  'calendar.add': 'Add',
  'calendar.noTimeSet': 'No time set',
  'calendar.durationMinutes': '{{count}} minutes',
  'calendar.startTutoringNow': 'Start Tutoring Now',
  'calendar.startTutoring': 'Start Tutoring',
  'calendar.newSessionModalTitle': 'New Session',
  'calendar.subjectLabel': 'Subject',
  'calendar.subjectPlaceholder': 'e.g., Mathematics, Science, History',
  'calendar.dateTimeLabel': 'Date and Time',
  'calendar.durationLabel': 'Duration (minutes)',
  'calendar.notesLabel': 'Notes',
  'calendar.notesPlaceholder': 'Additional notes...',
  'calendar.sending': 'Sending...',
  'dashboard.quickAccess.achievements': 'Achievements & Badges',
  'dashboard.quickAccess.liveSession': 'Live Session',
  'dashboard.recentActivity.practiceExam': 'Practice Exam',
  'dashboard.recentActivity.untitledHomework': 'Untitled Homework',
  'dashboard.recentActivity.noDetails': 'No details',
  'dashboard.recentActivity.studentFallback': 'Student',
  'dashboard.recentActivity.durationMinutes': 'Duration: {{minutes}} minutes',
  'dashboard.recentActivity.gamePlayed': '🎮 Played an educational game',
  'dashboard.recentActivity.activityCompleted': 'Activity completed',
  'dashboard.recentActivity.tutoringSession': 'Tutoring Session',
  'dashboard.viewFullReport': 'View full report',
  'dashboard.recentActivity.achievementUnlockedFallback': 'Achievement Unlocked',
  'dashboard.recentActivity.dateUnavailable': 'Date unavailable',
  'dashboard.recentActivity.justNow': 'Just now',
  'dashboard.recentActivity.minutesAgo': '{{count}}m ago',
  'dashboard.recentActivity.hoursAgo': '{{count}}h ago',
  'dashboard.recentActivity.daysAgo': '{{count}}d ago',
  'dashboard.editStudentModal.title': 'Edit Student',
  'dashboard.editStudentModal.updateInfo': 'Update student information as needed',
  'dashboard.editStudentModal.namePlaceholder': 'E.g.: John Smith',
  'dashboard.editStudentModal.ageHelp': 'Between 3 and 18 years',
  'dashboard.editStudentModal.ageRangeError': 'Age must be between 3 and 18 years',
  'dashboard.editStudentModal.updateSuccess': '✅ Student information updated successfully',
  'dashboard.editStudentModal.updateError': 'Error updating student information',
  'dashboard.editStudentModal.gradeOptions.grade1': '1st Grade',
  'dashboard.editStudentModal.gradeOptions.grade2': '2nd Grade',
  'dashboard.editStudentModal.gradeOptions.grade3': '3rd Grade',
  'dashboard.editStudentModal.gradeOptions.grade4': '4th Grade',
  'dashboard.editStudentModal.gradeOptions.grade5': '5th Grade',
  'dashboard.editStudentModal.gradeOptions.grade6': '6th Grade',
  'dashboard.editStudentModal.gradeOptions.grade7': '7th Grade',
  'dashboard.editStudentModal.gradeOptions.grade8': '8th Grade',
  'dashboard.editStudentModal.gradeOptions.grade9': '9th Grade',
  'dashboard.editStudentModal.gradeOptions.grade10': '10th Grade',
  'dashboard.editStudentModal.gradeOptions.grade11': '11th Grade',
  'dashboard.editStudentModal.gradeOptions.grade12': '12th Grade',

  // Reports Page (i18n coverage batch 2)
  'reports.noSubject': 'No subject',
  'reports.title': 'Reports',
  'reports.allStudents': 'All Students',
  'reports.period': 'Period',
  'reports.lastWeek': 'Last Week',
  'reports.lastMonth': 'Last Month',
  'reports.allTime': 'All Time',
  'reports.sessionsTotalTime': '{{time}} total',
  'reports.completionRate': 'Completion Rate',
  'reports.performanceByStudent': 'Performance by Student',
  'reports.noDataAvailable': 'No data available',
  'reports.activitiesCompleted': 'Activities Completed (HW + Sessions)',
  'reports.analysisBySubject': 'Analysis by Subject',
  'reports.noSubjectData': 'No subject data',
  'reports.activitySummary': 'Activity Summary',
  'reports.homeworkAssigned': 'Homework Assigned',
  'reports.studyTime': 'Study Time',
  'reports.studentLabel': 'Student',
  'reports.totalHomeworkLabel': 'Total Homework',
  'reports.sessionsLabel': 'Sessions',
  'reports.averageLabel': 'Average',
  'reports.achievementsLabel': 'Achievements',
  'reports.aiTutoringLabel': 'AI Tutoring',
  'subjects.mathematics': 'Mathematics',
  'subjects.science': 'Science',
  'subjects.socialStudies': 'Social Studies',
  'subjects.languageArts': 'Language Arts',
  'subjects.generalHelp': 'General Help',
  'subjects.liveSession': 'Live Session with Miss Ann',
  'subjects.liveSessionPrek': 'Live Session with Mini Miss Ann',
  'subjects.general': 'General',
  'subjects.legacyGameActivity': 'Game Activity',

  // Achievements Page /logros (i18n coverage batch 2)
  'achievements.loading': 'Loading achievements...',
  'achievements.pageTitle': '🏆 Achievements & Badges',
  'achievements.subtitle': 'Your achievements and rewards',
  'achievements.pointsCount': '{{points}} Points',
  'achievements.unlockedCount': 'You\'ve unlocked {{count}} achievements',
  'achievements.categories.all': 'All',
  'achievements.categories.study': 'Study',
  'achievements.categories.games': 'Games',
  'achievements.categories.streaks': 'Streaks',
  'achievements.categories.special': 'Special',
  'achievements.noAchievementsYet': 'No achievements yet',
  'achievements.noAchievementsInCategory': 'No achievements in this category',
  'achievements.keepGoing': 'Keep studying and playing to unlock amazing achievements!',
  'achievements.pointsBadge': '+{{points}} pts',
  'achievements.items.firstSession.title': '🚀 First Session',
  'achievements.items.firstSession.description': 'You completed your first tutoring session',
  'achievements.items.sessionMaster.title': '🧙‍♂️ Knowledge Wizard',
  'achievements.items.sessionMaster.description': 'You completed 5 tutoring sessions',
  'achievements.items.sessionLegend.title': '🏆 Study Legend',
  'achievements.items.sessionLegend.description': 'You completed 20 tutoring sessions',
  'achievements.items.homeworkStarter.title': '📝 First Steps',
  'achievements.items.homeworkStarter.description': 'You uploaded your first homework',
  'achievements.items.homeworkPro.title': '📚 Homework Pro',
  'achievements.items.homeworkPro.description': 'You completed 10 homework assignments',
  'achievements.items.gamePlayer.title': '🎮 Novice Player',
  'achievements.items.gamePlayer.description': 'You played your first educational game',
  'achievements.items.gameMaster.title': '🎯 Game Master',
  'achievements.items.gameMaster.description': 'You played 10 educational games',
  'achievements.items.streak3.title': '🔥 On Fire',
  'achievements.items.streak3.description': 'You studied for 3 days in a row',
  'achievements.items.streak7.title': '⚡ Unstoppable',
  'achievements.items.streak7.description': 'You studied for 7 days in a row',

  // Practice Tests Page /simulacros (i18n coverage batch 2)
  'practiceTests.title': 'Practice Tests',
  'practiceTests.subtitle': 'Practice with AI-generated exams',
  'practiceTests.back': '← Back',
  'practiceTests.selectStudentAndGrade': 'Please select a student and grade level',
  'practiceTests.generateError': 'Could not generate practice test. Please try again.',
  'practiceTests.confirmUnanswered': 'You have {{count}} unanswered questions. Do you want to submit anyway?',
  'practiceTests.evaluateError': 'Could not evaluate test. Please try again.',
  'practiceTests.examCompleted': 'Exam Completed!',
  'practiceTests.greatJob': 'Great job, {{name}}!',
  'practiceTests.score': 'Score',
  'practiceTests.correctAnswers': 'Correct answers',
  'practiceTests.difficultyLevel': 'Difficulty Level',
  'practiceTests.detailedResults': 'Detailed Results',
  'practiceTests.explanation': 'Explanation:',
  'practiceTests.newPracticeTest': 'New Practice Test',
  'practiceTests.questionsLabel': 'Questions',
  'practiceTests.previous': '← Previous',
  'practiceTests.evaluating': 'Evaluating...',
  'practiceTests.submitExam': 'Submit Exam',
  'practiceTests.next': 'Next →',
  'practiceTests.configureExam': 'Configure Exam',
  'practiceTests.selectStudentOption': 'Select a student...',
  'practiceTests.gradeLevel': 'Grade Level',
  'practiceTests.selectGradeLevelOption': 'Select grade level...',
  'practiceTests.grades.kindergarten': 'Kindergarten',
  'practiceTests.schoolQuarter': 'School Quarter',
  'practiceTests.quarters.q1Period': 'Aug - Oct',
  'practiceTests.quarters.q2Period': 'Oct - Dec',
  'practiceTests.quarters.q3Period': 'Jan - Mar',
  'practiceTests.quarters.q4Period': 'Mar - May',
  'practiceTests.subject': 'Subject',
  'practiceTests.subjects.mathematics': 'Mathematics',
  'practiceTests.subjects.science': 'Science',
  'practiceTests.subjects.spanish': 'Spanish',
  'practiceTests.subjects.english': 'English',
  'practiceTests.subjects.socialStudies': 'Social Studies',
  'practiceTests.subjects.history': 'History',
  'practiceTests.numberOfQuestions': 'Number of Questions: {{count}}',
  'practiceTests.difficulty.basic': 'Basic',
  'practiceTests.difficulty.intermediate': 'Inter',
  'practiceTests.difficulty.advanced': 'Adv',
  'practiceTests.generatingExam': 'Generating exam...',
  'practiceTests.startPracticeTest': 'Start Practice Test',
  'practiceTests.benefits.title': 'Benefits',
  'practiceTests.benefits.item1': 'AI-generated questions',
  'practiceTests.benefits.item2': 'Aligned with school curriculum',
  'practiceTests.benefits.item3': 'Instant feedback',
  'practiceTests.benefits.item4': 'Detailed explanations',
  'practiceTests.quarterSystem.title': 'Quarter System',
  'practiceTests.quarterSystem.description': 'Select the school quarter to generate questions aligned with the current curriculum period.',
  'practiceTests.statistics.title': 'Statistics',
  'practiceTests.statistics.testsCompleted': 'Tests completed',
  'practiceTests.statistics.averageScore': 'Average score',
  'practiceTests.tips.title': 'Tips',
  'practiceTests.tips.item1': 'Read each question carefully',
  'practiceTests.tips.item2': 'Take your time',
  'practiceTests.tips.item3': 'Review your answers',

  // Student Detail Page /estudiante (i18n coverage batch 2)
  'studentDetail.notFound': 'Student not found',
  'studentDetail.backToDashboard': 'Back to Dashboard',
  'studentDetail.navDashboard': 'Dashboard',
  'studentDetail.stats.completedHomework': 'Homework Completed',
  'studentDetail.stats.studyHours': 'Study Hours',
  'studentDetail.stats.average': 'Average',
  'studentDetail.tabs.summary': 'Summary',
  'studentDetail.tabs.sessions': 'Sessions ({{count}})',
  'studentDetail.tabs.achievements': 'Achievements ({{count}})',
  'studentDetail.tabs.homework': 'Homework ({{count}})',
  'studentDetail.noSessionsYet': 'No sessions recorded yet',
  'studentDetail.sessionsMinutes': '{{sessions}} sessions · {{minutes}} min',
  'studentDetail.noActivityRecorded': 'No activity recorded',
  'studentDetail.sessionOf': 'Session: {{subject}}',
  'studentDetail.minutesCompleted': '{{minutes}} minutes · {{percent}}% completed',
  'studentDetail.homeworkPrefix': 'Homework: {{title}}',
  'studentDetail.homeworkCompleted': 'Completed',
  'studentDetail.homeworkPending': 'Pending',
  'studentDetail.sessionHistory': 'Session History',
  'studentDetail.startFirstSession': 'Start First Session',
  'studentDetail.completedLabel': 'Completed',
  'studentDetail.minutesLabel': 'Minutes',
  'studentDetail.questionsLabel': 'Questions',
  'studentDetail.hintsLabel': 'Hints',
  'studentDetail.aiFeedback': 'AI Feedback',
  'studentDetail.unlockedAchievements': 'Unlocked Achievements',
  'studentDetail.noAchievementsUnlocked': 'No achievements unlocked yet',
  'studentDetail.studentHomeworkTitle': 'Student\'s Homework',
  'studentDetail.noHomeworkRecorded': 'No homework recorded',
  'studentDetail.uploadHomework': 'Upload Homework',
  'studentDetail.aiAnalysis': 'AI Analysis',
  'studentDetail.overallSummary': 'Overall Summary',
  'studentDetail.totalStudyTime': 'Total study time',
  'studentDetail.averageCompletion': 'Average completion',
  'simulacros.selectStudentAndGrade': 'Please select a student and grade level',
  'simulacros.studentNotFound': 'Student not found',
  'simulacros.errorGenerating': 'Error generating practice test',
  'simulacros.noQuestionsReceived': 'No questions received',
  'simulacros.couldNotGenerate': 'Could not generate practice test. Please try again.',
  'simulacros.unansweredConfirm': 'You have {{count}} unanswered questions. Do you want to submit anyway?',
  'simulacros.errorEvaluating': 'Error evaluating test',
  'simulacros.couldNotEvaluate': 'Could not evaluate test. Please try again.',
  'simulacros.examCompleted': 'Exam Completed!',
  'simulacros.greatJob': 'Great job, {{name}}!',
  'simulacros.score': 'Score',
  'simulacros.correctAnswers': 'Correct answers',
  'simulacros.difficultyLevel': 'Difficulty Level',
  'simulacros.detailedResults': 'Detailed Results',
  'simulacros.explanation': 'Explanation:',
  'simulacros.newPracticeTest': 'New Practice Test',
  'simulacros.questionsCount': 'Questions',
  'simulacros.previous': '← Previous',
  'simulacros.next': 'Next →',
  'simulacros.evaluating': 'Evaluating...',
  'simulacros.submitExam': 'Submit Exam',
  'simulacros.subtitle': 'Practice with AI-generated exams',
  'simulacros.configureExam': 'Configure Exam',
  'simulacros.selectStudent': 'Select Student',
  'simulacros.selectStudentPlaceholder': 'Select a student...',
  'simulacros.gradeLevel': 'Grade Level',
  'simulacros.selectGradePlaceholder': 'Select grade level...',
  'simulacros.grades.preschool': 'Preschool',
  'simulacros.grades.grade1': '1st Grade',
  'simulacros.grades.grade2': '2nd Grade',
  'simulacros.grades.grade3': '3rd Grade',
  'simulacros.grades.grade4': '4th Grade',
  'simulacros.grades.grade5': '5th Grade',
  'simulacros.grades.grade6': '6th Grade',
  'simulacros.grades.grade7': '7th Grade',
  'simulacros.grades.grade8': '8th Grade',
  'simulacros.grades.grade9': '9th Grade',
  'simulacros.grades.grade10': '10th Grade',
  'simulacros.grades.grade11': '11th Grade',
  'simulacros.grades.grade12': '12th Grade',
  'simulacros.schoolQuarter': 'School Quarter',
  'simulacros.quarters.q1Period': 'Aug - Oct',
  'simulacros.quarters.q2Period': 'Nov - Dec',
  'simulacros.quarters.q3Period': 'Jan - Mar',
  'simulacros.quarters.q4Period': 'Apr - Jun',
  'simulacros.subject': 'Subject',
  'simulacros.subjects.mathematics': 'Mathematics',
  'simulacros.subjects.science': 'Science',
  'simulacros.subjects.spanish': 'Spanish',
  'simulacros.subjects.english': 'English',
  'simulacros.subjects.socialStudies': 'Social Studies',
  'simulacros.subjects.history': 'History',
  'simulacros.numberOfQuestions': 'Number of Questions: {{count}}',
  'simulacros.difficulty.basic': 'Basic',
  'simulacros.difficulty.intermediate': 'Inter',
  'simulacros.difficulty.advanced': 'Adv',
  'simulacros.generatingExam': 'Generating exam...',
  'simulacros.startPracticeTest': 'Start Practice Test',
  'simulacros.benefits': 'Benefits',
  'simulacros.benefit1': 'AI-generated questions',
  'simulacros.benefit2': 'Aligned with school curriculum',
  'simulacros.benefit3': 'Instant feedback',
  'simulacros.benefit4': 'Detailed explanations',
  'simulacros.quarterSystem': 'Quarter System',
  'simulacros.quarterSystemDesc': 'Select the school quarter to generate questions aligned with the current curriculum period.',
  'simulacros.statistics': 'Statistics',
  'simulacros.testsCompleted': 'Tests completed',
  'simulacros.averageScore': 'Average score',
  'simulacros.tips': 'Tips',
  'simulacros.tip1': 'Read each question carefully',
  'simulacros.tip2': 'Take your time',
  'simulacros.tip3': 'Review your answers',

  // Games Intro/Selection Screens (i18n coverage batch 3)
  'games.selectStudentAlert': 'Please select a student on the Dashboard before playing.',
  'games.noActiveStudentAlert': '⚠️ Error: No active student detected. Go back to the Dashboard to select one.',
  'games.listenAgain': 'Listen again',

  // Pre-K/1st Grade module: Letter Sounds (phonemic awareness, no reading required)
  'games.letterSounds.title': 'Letter Sounds',
  'games.letterSounds.subtitle': 'Listen to the sound and tap the right picture',
  'games.letterSounds.howToPlay': 'How to Play',
  'games.letterSounds.step1': 'Listen',
  'games.letterSounds.step1Desc': 'Pay attention to the sound you hear',
  'games.letterSounds.step2': 'Tap',
  'games.letterSounds.step2Desc': 'Choose the picture that starts with that sound',
  'games.letterSounds.step3': 'Celebrate',
  'games.letterSounds.step3Desc': 'Earn points and keep learning!',
  'games.letterSounds.startGame': 'Start Playing',
  'games.letterSounds.promptAudio': 'Which picture starts with the sound {{sound}}?',
  'games.letterSounds.question': 'Which one starts with this sound?',
  'games.letterSounds.correctCelebration': 'Great job!',

  // Pre-K/1st Grade module: Fun Counting (no reading required)
  'games.counting.title': 'Fun Counting',
  'games.counting.subtitle': 'Listen to the number and tap the right group',
  'games.counting.step1': 'Listen',
  'games.counting.step1Desc': 'Pay attention to the number you hear',
  'games.counting.step2': 'Count',
  'games.counting.step2Desc': 'Tap the group that has that many',
  'games.counting.step3': 'Celebrate',
  'games.counting.step3Desc': 'Earn points and keep counting!',
  'games.counting.promptAudio': 'Tap the group that has {{count}} {{object}}',
  'games.counting.question': 'Where are there {{count}} {{object}}?',
  'games.counting.correctCelebration': "That's right! It's {{count}}. Great counting!",
  'games.counting.wrongFeedback': 'The correct answer was {{count}}. Let\'s try again!',

  // Emoji Zoo Game - Intro Screen
  'games.zoo.startGame': 'Start Game',
  'games.zoo.selectDifficultyFirst': 'Select difficulty first',
  'games.zoo.whatWillYouLearn': 'What will you learn?',
  'games.zoo.alphabetRecognition': 'Alphabet Recognition',
  'games.zoo.alphabetRecognitionDesc': 'Learn all letters in a fun way',
  'games.zoo.visualMemory': 'Visual Memory',
  'games.zoo.visualMemoryDesc': 'Improve your memory with animals',
  'games.zoo.handEyeCoordination': 'Hand-Eye Coordination',
  'games.zoo.handEyeCoordinationDesc': 'Develop motor skills',
  'games.zoo.vocabulary': 'Vocabulary',
  'games.zoo.vocabularyDesc': 'Learn new words in English',

  // Math Games - Intro Screen
  'games.math.pageTitle': '🔢 Math Games',
  'games.math.pageSubtitle': 'Choose your favorite math adventure',
  'games.math.bannerTitle': '4 Different Ways to Learn',
  'games.math.bannerDesc': 'Each game has a unique style for you to practice math in a fun way. Choose the one you like best or try them all to master numbers.',
  'games.math.levelLabel': 'Level:',
  'games.math.featuresLabel': 'Features:',
  'games.math.tipsTitle': '💡 Tips to Improve',
  'games.math.tip1Title': 'Practice daily',
  'games.math.tip1Desc': '10-15 minutes a day improves your mental speed',
  'games.math.tip2Title': 'Set goals',
  'games.math.tip2Desc': 'Try to beat your personal record every day',
  'games.math.tip3Title': 'Learn from mistakes',
  'games.math.tip3Desc': 'Review explanations when you fail',
  'games.math.tip4Title': 'Vary the games',
  'games.math.tip4Desc': 'Each game develops different skills',
  'games.math.games.desafioRapido.name': 'Quick Math Challenge',
  'games.math.games.desafioRapido.description': 'Solve problems against the clock and improve your mental speed',
  'games.math.games.desafioRapido.feature1': 'Time limit per problem',
  'games.math.games.desafioRapido.feature2': 'Multiple operations',
  'games.math.games.desafioRapido.feature3': 'Speed points',
  'games.math.games.desafioRapido.feature4': 'Difficulty levels',
  'games.math.games.desafioRapido.difficulty': 'All levels',
  'games.math.games.aventura.name': 'Math Adventure',
  'games.math.games.aventura.description': 'Help the explorer find the treasure by solving problems',
  'games.math.games.aventura.feature1': 'Interactive story',
  'games.math.games.aventura.feature2': 'Missions and characters',
  'games.math.games.aventura.feature3': 'Contextualized problems',
  'games.math.games.aventura.feature4': 'Special rewards',
  'games.math.games.aventura.difficulty': 'Kinder - 6th grade',
  'games.math.games.dueloNumeros.name': 'Number Duel',
  'games.math.games.dueloNumeros.description': 'Compete against time in a streak of progressive problems',
  'games.math.games.dueloNumeros.feature1': 'Progressive difficulty',
  'games.math.games.dueloNumeros.feature2': 'Streak system',
  'games.math.games.dueloNumeros.feature3': 'Record table',
  'games.math.games.dueloNumeros.feature4': 'Daily challenges',
  'games.math.games.dueloNumeros.difficulty': '3rd - 6th grade',
  'games.math.games.memoryMatch.name': 'Math Memory Match',
  'games.math.games.memoryMatch.description': 'Find matching pairs of math problems and answers',
  'games.math.games.memoryMatch.feature1': 'Classic memory game',
  'games.math.games.memoryMatch.feature2': 'Match problems with answers',
  'games.math.games.memoryMatch.feature3': 'Multiple grade levels',
  'games.math.games.memoryMatch.feature4': 'Improve mental math',
  'games.math.games.memoryMatch.difficulty': 'Kinder - 3rd grade',

  // Geo Mystery - Intro Screen
  'games.geoMystery.pageTitle': '🌍 Where in the world is...?',
  'games.geoMystery.pageSubtitle': 'Discover mysterious countries with AI clues',
  'games.geoMystery.howToPlay': 'How to play?',
  'games.geoMystery.rule1': 'The AI "hides" in a country of the world',
  'games.geoMystery.rule2': 'You will receive progressive clues about the country',
  'games.geoMystery.rule3': 'Guess with fewer clues to earn more points',
  'games.geoMystery.rule4': 'Learn geography in a fun way',
  'games.geoMystery.rule5': 'Discover fascinating facts about each country',
  'games.geoMystery.difficulties.easy.name': 'Easy',
  'games.geoMystery.difficulties.easy.description': 'Famous countries with 5 clues',
  'games.geoMystery.difficulties.medium.name': 'Medium',
  'games.geoMystery.difficulties.medium.description': 'Various countries with 4 clues',
  'games.geoMystery.difficulties.hard.name': 'Hard',
  'games.geoMystery.difficulties.hard.description': 'Challenging countries with 3 clues',
  'games.geoMystery.numberOfClues': 'Number of clues:',
  'games.geoMystery.pointsSystem': 'Points system:',
  'games.geoMystery.clueLabel': 'Clue {{number}}:',
  'games.geoMystery.pts': 'pts',
  'games.geoMystery.tipEasy': 'Perfect to start. Very well-known countries with many clues.',
  'games.geoMystery.tipMedium': 'A balanced challenge. Countries from around the world.',
  'games.geoMystery.tipHard': 'For experts! Less known countries with few clues.',
  'games.geoMystery.exampleTitle': 'Game example',
  'games.geoMystery.firstClue': 'First Clue:',
  'games.geoMystery.secondClue': 'Second Clue:',
  'games.geoMystery.thirdClue': 'Third Clue:',
  'games.geoMystery.exampleClue1': '"I am on a continent where there are many kangaroos"',
  'games.geoMystery.exampleClue2': '"My flag has stars and is blue, red and white"',
  'games.geoMystery.exampleClue3': '"I have a famous opera house shaped like sails"',
  'games.geoMystery.exampleAnswer': 'Answer: Australia! 🇦🇺',

  // Dr. AI - Intro Screen
  'games.drIA.pageTitle': '🩺 Dr. AI Diagnosis',
  'games.drIA.pageSubtitle': 'Learn anatomy by diagnosing virtual patients',
  'games.drIA.howToPlay': 'How to Play?',
  'games.drIA.rule1': 'A virtual patient describes their symptoms',
  'games.drIA.rule2': 'Carefully analyze the symptoms',
  'games.drIA.rule3': 'Choose which body system to examine',
  'games.drIA.rule4': 'Select the correct diagnosis',
  'games.drIA.rule5': 'Learn about anatomy and body systems',
  'games.drIA.systems.circulatory.title': 'Circulatory System',
  'games.drIA.systems.circulatory.description': 'Heart, arteries, veins, and blood. Transports oxygen and nutrients.',
  'games.drIA.systems.circulatory.symptoms': 'Chest pain, palpitations, fatigue',
  'games.drIA.systems.circulatoryShort': 'Heart and blood vessels',
  'games.drIA.systems.respiratory.title': 'Respiratory System',
  'games.drIA.systems.respiratory.description': 'Lungs, trachea, and bronchi. Enables breathing and oxygen intake.',
  'games.drIA.systems.respiratory.symptoms': 'Cough, shortness of breath, chest pain',
  'games.drIA.systems.respiratoryShort': 'Lungs and airways',
  'games.drIA.systems.digestive.title': 'Digestive System',
  'games.drIA.systems.digestive.description': 'Stomach, intestines, and liver. Processes food and nutrients.',
  'games.drIA.systems.digestive.symptoms': 'Abdominal pain, nausea, diarrhea',
  'games.drIA.systems.digestiveShort': 'Stomach and intestines',
  'games.drIA.systems.nervous.title': 'Nervous System',
  'games.drIA.systems.nervous.description': 'Brain, spinal cord, and nerves. Controls body functions and senses.',
  'games.drIA.systems.nervous.symptoms': 'Headaches, dizziness, numbness',
  'games.drIA.systems.nervousShort': 'Brain and nerves',
  'games.drIA.commonSymptomsLabel': 'Common symptoms:',
  'games.drIA.difficulties.easy.name': 'Beginner',
  'games.drIA.difficulties.easy.description': 'Simple cases with very clear symptoms',
  'games.drIA.difficulties.medium.name': 'Junior Doctor',
  'games.drIA.difficulties.medium.description': 'Moderate cases with multiple symptoms',
  'games.drIA.difficulties.hard.name': 'Specialist',
  'games.drIA.difficulties.hard.description': 'Complex cases requiring detailed analysis',
  'games.drIA.casesToSolve': 'Cases to solve:',
  'games.drIA.pointsPerCase': 'Points per case:',
  'games.drIA.tipEasy': 'Perfect to start. Very clear and direct symptoms.',
  'games.drIA.tipMedium': 'More complex cases with multiple symptoms.',
  'games.drIA.tipHard': 'For experts! Requires detailed analysis.',
  'games.drIA.startDiagnosis': 'Start Diagnosis',
  'games.drIA.exampleTitle': 'Medical Case Example',
  'games.drIA.virtualPatientLabel': 'Virtual Patient:',
  'games.drIA.examplePatientText': '"Hello doctor, my chest hurts when I run and I feel short of breath. I also notice my heart beats very fast."',
  'games.drIA.respiratorySelected': 'Respiratory System ✓',
  'games.drIA.correctDiagnosisLabel': 'Correct Diagnosis:',
  'games.drIA.exampleDiagnosis': 'Exercise-induced asthma',
  'games.drIA.exampleDiagnosisSuffix': '- Respiratory system problem',
  'games.drIA.exampleExplanation': 'Asthma causes inflammation in the airways, making breathing difficult during exercise. Symptoms include shortness of breath, coughing, and chest tightness.',

  // Secret Words - Intro Screen
  'games.secretWords.intro.title': '🔤 Secret Words Challenge',
  'games.secretWords.intro.subtitle': 'Guess educational words with AI hints',
  'games.secretWords.intro.howToPlay': 'How to Play?',
  'games.secretWords.intro.rule1': 'Guess the hidden word letter by letter',
  'games.secretWords.intro.rule2': 'Use AI-generated hints when you need them',
  'games.secretWords.intro.rule3': 'You have 6 attempts before losing',
  'games.secretWords.intro.rule4': 'Earn 10 points for each correct word',
  'games.secretWords.intro.rule5': 'Learn vocabulary while having fun!',
  'games.secretWords.intro.configTitle': '⚙️ Game Configuration',
  'games.secretWords.intro.languageLabel': '🌐 Game Language',
  'games.secretWords.intro.gradeLabel': '🎓 Select Grade',
  'games.secretWords.intro.subjectLabel': '📚 Select Subject',
  'games.secretWords.intro.topicLabel': '🎯 Select Topic',
  'games.secretWords.intro.startButton': '🎮 Start Playing!',
  'games.secretWords.intro.completeConfig': '⚠️ Complete configuration',
  'games.secretWords.intro.feature1Title': 'Dynamic AI',
  'games.secretWords.intro.feature1Desc': 'Words and hints are generated in real-time by artificial intelligence',
  'games.secretWords.intro.feature2Title': 'Smart Hints',
  'games.secretWords.intro.feature2Desc': 'Receive cryptic hints that help you think and learn',
  'games.secretWords.intro.feature3Title': 'Bilingual',
  'games.secretWords.intro.feature3Desc': 'Play in Spanish or English to practice both languages',

  // Time Machine - Intro & Chat Screens
  'games.timeMachine.badge': 'History Game',
  'games.timeMachine.pageTitle': 'The Time Machine',
  'games.timeMachine.pageSubtitle': 'Travel to the past and interview historical figures',
  'games.timeMachine.howItWorks': 'How does it work?',
  'games.timeMachine.step1': 'Choose a famous historical figure',
  'games.timeMachine.step2': 'Read your mission and key questions',
  'games.timeMachine.step3': 'Chat with the character (AI adopts their personality)',
  'games.timeMachine.step4': 'Ask the right questions to earn points',
  'games.timeMachine.step5': 'Learn history in a fun way',
  'games.timeMachine.missionLabel': 'Your Mission:',
  'games.timeMachine.suggestedQuestionsLabel': 'Some suggested questions:',
  'games.timeMachine.moreQuestions': '...and 5 more questions to discover',
  'games.timeMachine.startAdventure': 'Start Adventure',
  'games.timeMachine.chat.exit': '← Exit',
  'games.timeMachine.chat.points': 'Points',
  'games.timeMachine.chat.keyQuestions': 'Key Questions',
  'games.timeMachine.chat.totalQuestions': 'Total Questions',
  'games.timeMachine.chat.missionProgress': 'Mission Progress',
  'games.timeMachine.chat.placeholder': 'Type your question here...',
  'games.timeMachine.chat.send': 'Send',
  'games.timeMachine.chat.suggestedQuestions': '💡 Suggested Questions (10 in total, 3 are key and worth 10 points each):',
  'games.timeMachine.chat.foundProgress': '🎯 You have found {{count}} of 3 key questions. Keep exploring!',
  'games.timeMachine.chat.welcomeMessage': 'Hello! I am {{name}}, {{title}}. I have traveled from the year {{period}} to speak with you. Your mission is: {{mission}} Ask me questions and learn about my life and my time! There are 3 secret key questions that will give you 10 points each. Can you discover them?',
  'games.timeMachine.chat.bonusMessage': '🎉 Excellent question! You have discovered a key question. You have earned 10 points. ({{count}}/3 key questions found)',
  'games.timeMachine.chat.connectionError': 'Sorry, there was a problem connecting with the historical character. Please verify that the OpenAI API is configured correctly and try again.',

  // Geo Mystery - Play Screen
  'games.geoMystery.generatingCountries': 'Generating mysterious countries...',
  'games.geoMystery.preparingAdventure': 'Preparing your geographic adventure 🌍',
  'games.geoMystery.generateErrorAlert': 'Error generating the game. Please try again.',
  'games.geoMystery.roundLabel': 'Round {{current}} of {{total}}',
  'games.geoMystery.whatCountryAmI': 'What country am I?',
  'games.geoMystery.useCluesSubtitle': 'Use the clues to discover it',
  'games.geoMystery.availableCluesHeading': 'Available Clues',
  'games.geoMystery.cluesRevealedCount': '{{revealed}} / {{max}} revealed',
  'games.geoMystery.revealNextClueButton': 'Reveal Next Clue',
  'games.geoMystery.minusPtsSuffix': '(-{{points}} pts)',
  'games.geoMystery.yourAnswerHeading': 'Your Answer',
  'games.geoMystery.countryInputPlaceholder': 'Type the country name...',
  'games.geoMystery.checkingLabel': 'Checking...',
  'games.geoMystery.checkAnswerButton': 'Check Answer',
  'games.geoMystery.pressEnterHint': 'Press Enter to submit your answer',
  'games.geoMystery.cluesUsedSingular': 'You used {{count}} clue',
  'games.geoMystery.cluesUsedPlural': 'You used {{count}} clues',
  'games.geoMystery.correctFeedback': '🎉 Correct! It\'s {{country}}!\n\n✨ {{cluesText}}\n🏆 +{{points}} points',
  'games.geoMystery.incorrectFeedback': '❌ Incorrect. Try again!\n\n💡 Tip: Reveal more clues if you need help',
  'games.geoMystery.gameCompleteTitle': 'Game Complete!',
  'games.geoMystery.gameCompleteSubtitle': 'Great job exploring the world!',
  'games.geoMystery.accuracyLabel': 'Accuracy',
  'games.geoMystery.performanceHeading': 'Performance',
  'games.geoMystery.perfectMessage': 'Perfect! You are a geography master!',
  'games.geoMystery.excellentMessage': 'Excellent! You know the world well!',
  'games.geoMystery.goodJobMessage': 'Good job! Keep exploring!',
  'games.geoMystery.keepPracticingMessage': 'Keep practicing! Every game makes you better!',
  'games.geoMystery.backToMenuButton': '🏠 Back to Menu',

  // Math Games - Shared gameplay strings (Math Adventure, Quick Math Challenge, Number Duel, Memory Match)
  'games.math.exitGame': 'Exit Game',
  'games.math.backToMenu': 'Back to Menu',
  'games.math.checkAnswer': 'Check Answer',
  'games.math.answerPlaceholder': 'Your answer',
  'games.math.incorrectTryAgain': 'Incorrect, try again',
  'games.math.playAgain': '🔄 Play Again',
  'games.math.pointsColon': 'Points:',
  'games.math.pointsLabel': 'Points',
  'games.math.solvedLabel': 'Solved',
  'games.math.streakLabel': 'Streak',
  'games.math.timeLabel': 'Time',
  'games.math.livesLabel': 'Lives',
  'games.math.livesColon': 'Lives:',
  'games.math.problemsSolvedLabel': 'Problems Solved',
  'games.math.bestStreakLabel': 'Best Streak',
  'games.math.problemNumberLabel': 'Problem #{{number}}',
  'games.math.secondsLabel': 'seconds',
  'games.math.streakOf': 'Streak of {{count}}',
  'games.math.extraPointsSuffix': '(+{{points}} extra points)',
  'games.math.operations.addition': 'Addition',
  'games.math.operations.subtraction': 'Subtraction',
  'games.math.operations.multiplication': 'Multiplication',
  'games.math.operations.division': 'Division',
  'games.math.operations.mixed': 'Mixed',

  // Math Adventure - Gameplay
  'games.math.aventura.subtitle': 'Find the treasure by solving problems!',
  'games.math.aventura.mapAlt': 'Treasure map',
  'games.math.aventura.storyHeading': '📖 The Story',
  'games.math.aventura.storyP1Pre': 'You are a brave explorer who has discovered an ancient map that leads to a legendary treasure. To find it, you must overcome ',
  'games.math.aventura.storyP1Bold': '10 math missions',
  'games.math.aventura.storyP1Post': ' full of adventures.',
  'games.math.aventura.storyP2': 'Each mission will bring you closer to the final treasure. Are you ready for the adventure? 🗺️',
  'games.math.aventura.howToPlayHeading': '🎯 How to Play',
  'games.math.aventura.step1': 'Read the story of each mission',
  'games.math.aventura.step2': 'Solve the math problem',
  'games.math.aventura.step3Pre': 'Earn ',
  'games.math.aventura.step3Bold': '10 points',
  'games.math.aventura.step3Post': ' per correct answer',
  'games.math.aventura.step4': 'You can ask for a hint (-2 points)',
  'games.math.aventura.step5': 'Complete all 10 missions to find the treasure!',
  'games.math.aventura.startButton': '🚀 Start Adventure',
  'games.math.aventura.completeTitle': 'Adventure Complete!',
  'games.math.aventura.completeSubtitle': 'You found the legendary treasure!',
  'games.math.aventura.treasureFoundAlt': 'Treasure found',
  'games.math.aventura.treasuresFoundLabel': 'Treasures Found',
  'games.math.aventura.congratsTitle': 'Congratulations Explorer!',
  'games.math.aventura.congratsMessage': 'You have proven to be a great mathematician and adventurer. The legendary treasure is yours. Well done!',
  'games.math.aventura.newAdventureButton': '🔄 New Adventure',
  'games.math.aventura.progressLabel': 'Adventure Progress',
  'games.math.aventura.treasuresLabel': 'Treasures:',
  'games.math.aventura.missionLabel': 'Mission {{number}}',
  'games.math.aventura.solveTheProblem': 'Solve the Problem',
  'games.math.aventura.mathChallenge': 'Math Challenge',
  'games.math.aventura.operationLabel': 'Operation:',
  'games.math.aventura.hintLabel': '💡 Hint',
  'games.math.aventura.showHintButton': '💡 Show Hint (-2 points)',

  'games.math.aventura.mission1.title': 'The Treasure Map',
  'games.math.aventura.mission1.story': '🗺️ You found an ancient map. To decipher the first clue, you need to solve this problem...',
  'games.math.aventura.mission1.problem': 'The map shows 3 islands. On each island there are 4 palm trees. How many palm trees are there in total?',
  'games.math.aventura.mission1.context': '3 islands × 4 palm trees',
  'games.math.aventura.mission1.hint': 'Multiply the number of islands by the palm trees on each one',
  'games.math.aventura.mission1.reward': 'You discovered the location of the first island! 🏝️',
  'games.math.aventura.mission2.title': 'The Hanging Bridge',
  'games.math.aventura.mission2.story': '🌉 You arrive at a hanging bridge. To cross it safely, you must calculate...',
  'games.math.aventura.mission2.problem': 'The bridge is 45 meters long. You have already walked 18 meters. How many meters do you have left?',
  'games.math.aventura.mission2.context': '45 meters - 18 meters',
  'games.math.aventura.mission2.hint': 'Subtract what you already walked from the total',
  'games.math.aventura.mission2.reward': 'You crossed the bridge successfully! 🎉',
  'games.math.aventura.mission3.title': 'The Mysterious Cave',
  'games.math.aventura.mission3.story': '🕳️ You enter a dark cave. You find chests with gold coins...',
  'games.math.aventura.mission3.problem': 'There are 6 chests. Each chest has 8 gold coins. How many coins do you have in total?',
  'games.math.aventura.mission3.context': '6 chests × 8 coins',
  'games.math.aventura.mission3.hint': 'Multiply the chests by the coins in each one',
  'games.math.aventura.mission3.reward': 'You collected all the coins! 💰',
  'games.math.aventura.mission4.title': 'The Rushing River',
  'games.math.aventura.mission4.story': '🌊 You need to cross a river. You must distribute the supplies on the rafts...',
  'games.math.aventura.mission4.problem': 'You have 36 supplies and 4 rafts. How many supplies go on each raft?',
  'games.math.aventura.mission4.context': '36 supplies ÷ 4 rafts',
  'games.math.aventura.mission4.hint': 'Divide the supplies among the rafts',
  'games.math.aventura.mission4.reward': 'You crossed the river safely! 🚣',
  'games.math.aventura.mission5.title': 'The Sacred Mountain',
  'games.math.aventura.mission5.story': '⛰️ You climb a steep mountain. You need to calculate the height...',
  'games.math.aventura.mission5.problem': 'You climb 125 meters, rest, and climb 87 more meters. What height are you at?',
  'games.math.aventura.mission5.context': '125 meters + 87 meters',
  'games.math.aventura.mission5.hint': 'Add the two heights',
  'games.math.aventura.mission5.reward': 'You reached the summit! 🏔️',
  'games.math.aventura.mission6.title': 'The Ancient Temple',
  'games.math.aventura.mission6.story': '🏛️ You find a temple with numbered doors. To open them...',
  'games.math.aventura.mission6.problem': 'The door has the code: 15 × 7. What is the number?',
  'games.math.aventura.mission6.context': '15 × 7',
  'games.math.aventura.mission6.hint': 'Multiply 15 by 7',
  'games.math.aventura.mission6.reward': 'The doors opened! 🚪',
  'games.math.aventura.mission7.title': 'The Gem Garden',
  'games.math.aventura.mission7.story': '💎 You enter a garden full of precious gems...',
  'games.math.aventura.mission7.problem': 'You collect 8 red gems, 12 blue ones and 15 green ones. How many gems do you have?',
  'games.math.aventura.mission7.context': '8 + 12 + 15',
  'games.math.aventura.mission7.hint': 'Add all the gems',
  'games.math.aventura.mission7.reward': 'Your bag is full of gems! 💎',
  'games.math.aventura.mission8.title': 'The Mirror Maze',
  'games.math.aventura.mission8.story': '🪞 You enter a confusing maze. To find the exit...',
  'games.math.aventura.mission8.problem': 'You take 24 steps north, 16 south. How many net steps did you advance north?',
  'games.math.aventura.mission8.context': '24 steps - 16 steps',
  'games.math.aventura.mission8.hint': 'Subtract the steps south from the steps north',
  'games.math.aventura.mission8.reward': 'You found the exit! 🎯',
  'games.math.aventura.mission9.title': 'The Golden Waterfall',
  'games.math.aventura.mission9.story': '💧 You arrive at a magical waterfall with floating coins...',
  'games.math.aventura.mission9.problem': '144 coins fall. You distribute them among 12 friends. How many does each one get?',
  'games.math.aventura.mission9.context': '144 coins ÷ 12 friends',
  'games.math.aventura.mission9.hint': 'Divide the coins among the friends',
  'games.math.aventura.mission9.reward': 'Everyone received their fair share! 🤝',
  'games.math.aventura.mission10.title': 'The Final Treasure',
  'games.math.aventura.mission10.story': '🏆 You reached the final treasure! But it is protected by one last riddle...',
  'games.math.aventura.mission10.problem': 'The chest has 3 locks. Each lock needs 25 gems. How many gems do you need?',
  'games.math.aventura.mission10.context': '3 locks × 25 gems',
  'games.math.aventura.mission10.hint': 'Multiply the locks by the gems needed',
  'games.math.aventura.mission10.reward': '🎊 YOU FOUND THE LEGENDARY TREASURE! 🎊',

  // Quick Math Challenge - Gameplay
  'games.math.desafioRapido.subtitle': 'Solve problems against the clock!',
  'games.math.desafioRapido.selectDifficulty': 'Select Difficulty',
  'games.math.desafioRapido.operationType': 'Operation Type',
  'games.math.desafioRapido.gameRulesHeading': '📋 Game Rules',
  'games.math.desafioRapido.rule1Pre': 'You have ',
  'games.math.desafioRapido.rule1Bold': '30 seconds',
  'games.math.desafioRapido.rule1Post': ' per problem',
  'games.math.desafioRapido.rule2Pre': 'Earn ',
  'games.math.desafioRapido.rule2Bold': '10 base points',
  'games.math.desafioRapido.rule2Post': ' + speed bonuses',
  'games.math.desafioRapido.rule3Bold': 'Streaks',
  'games.math.desafioRapido.rule3Post': ' give you extra points',
  'games.math.desafioRapido.rule4': 'Solve as many as you can!',
  'games.math.desafioRapido.startButton': '🚀 Start Challenge',
  'games.math.desafioRapido.gameOverTitle': 'Game Over!',
  'games.math.desafioRapido.gameOverSubtitle': 'Here are your results',
  'games.math.desafioRapido.averagePerProblem': 'Average per Problem',
  'games.math.desafioRapido.problemLabel': 'Problem:',
  'games.math.desafioRapido.tipBold': 'Tip:',
  'games.math.desafioRapido.tipText': 'Answer quickly to earn time bonus points',

  // Number Duel - Gameplay
  'games.math.dueloNumeros.subtitle': 'Compete against time in an epic streak!',
  'games.math.dueloNumeros.levelColon': 'Level:',
  'games.math.dueloNumeros.gameModeHeading': '🎮 Game Mode',
  'games.math.dueloNumeros.introP1Pre': 'In this intense challenge, problems become ',
  'games.math.dueloNumeros.introP1Bold': 'more difficult',
  'games.math.dueloNumeros.introP1Post': ' as you progress. Keep your streak of correct answers to earn extra points.',
  'games.math.dueloNumeros.introP2Pre': 'But be careful! You only have ',
  'games.math.dueloNumeros.introP2Bold': '3 lives',
  'games.math.dueloNumeros.introP2Post': ' and time is running. How many problems can you solve?',
  'games.math.dueloNumeros.feature1Title': '3 Lives',
  'games.math.dueloNumeros.feature1Desc': 'Lose them and game over',
  'games.math.dueloNumeros.feature2Title': 'Time Limit',
  'games.math.dueloNumeros.feature2Desc': '20 seconds per problem',
  'games.math.dueloNumeros.feature3Title': 'Streak System',
  'games.math.dueloNumeros.feature3Desc': 'More streaks = more points',
  'games.math.dueloNumeros.feature4Title': 'Progressive Difficulty',
  'games.math.dueloNumeros.feature4Desc': 'Level up every 5 problems',
  'games.math.dueloNumeros.pointsSystemHeading': '💎 Points System',
  'games.math.dueloNumeros.pointsRule1Bold': '10 base points',
  'games.math.dueloNumeros.pointsRule1Post': ' per correct answer',
  'games.math.dueloNumeros.pointsRule2Bold': 'Time bonus:',
  'games.math.dueloNumeros.pointsRule2Post': ' Faster = more points',
  'games.math.dueloNumeros.pointsRule3Bold': 'Level bonus:',
  'games.math.dueloNumeros.pointsRule3Post': ' Level × 5 extra points',
  'games.math.dueloNumeros.pointsRule4Bold': 'Streak bonus:',
  'games.math.dueloNumeros.pointsRule4Post': ' Streak × 3 extra points',
  'games.math.dueloNumeros.startButton': '🚀 Start Duel',
  'games.math.dueloNumeros.duelOverTitle': 'Duel Over!',
  'games.math.dueloNumeros.duelOverSubtitle': 'Here are your stats',
  'games.math.dueloNumeros.levelValue': 'Level {{level}}',
  'games.math.dueloNumeros.levelReachedLabel': 'Level Reached',
  'games.math.dueloNumeros.achievementUnlockedTitle': 'Achievement Unlocked!',
  'games.math.dueloNumeros.streakMasterBold': 'Streak Master',
  'games.math.dueloNumeros.streakMasterText': ' - You got a streak of {{count}}',
  'games.math.dueloNumeros.levelChampionBold': 'Level Champion',
  'games.math.dueloNumeros.levelChampionText': ' - You reached level {{level}}',
  'games.math.dueloNumeros.difficultyLabel': 'Difficulty',
  'games.math.dueloNumeros.incorrectLostLife': 'Incorrect - Lost a life',
  'games.math.dueloNumeros.levelUpTitle': '🎉 Level Up to {{level}}! 🎉',
  'games.math.dueloNumeros.levelUpDesc': 'Problems are now more difficult',

  // Math Memory Match - Gameplay
  'games.math.memoryMatch.subtitle': 'Find matching pairs of problems and answers',
  'games.math.memoryMatch.gradeK': 'Kinder',
  'games.math.memoryMatch.grade1': '1st Grade',
  'games.math.memoryMatch.grade2': '2nd Grade',
  'games.math.memoryMatch.grade3': '3rd Grade',
  'games.math.memoryMatch.matchesLabel': 'Matches',
  'games.math.memoryMatch.movesLabel': 'Moves',
  'games.math.memoryMatch.gradeLabel': 'Grade',
  'games.math.memoryMatch.selectGradeLevel': 'Select Grade Level',
  'games.math.memoryMatch.newGameButton': '🔄 New Game',
  'games.math.memoryMatch.congratulationsTitle': 'Congratulations!',
  'games.math.memoryMatch.congratsMessage': 'You found all the matching pairs!',
  'games.math.memoryMatch.backToGames': 'Back to Games',
  'games.math.memoryMatch.howToPlayHeading': '📖 How to Play',
  'games.math.memoryMatch.step1Title': 'Click on cards',
  'games.math.memoryMatch.step1Desc': 'Flip two cards to reveal their content',
  'games.math.memoryMatch.step2Title': 'Find matches',
  'games.math.memoryMatch.step2Desc': 'Match math problems with their answers',
  'games.math.memoryMatch.step3Title': 'Remember positions',
  'games.math.memoryMatch.step3Desc': 'Use your memory to find pairs faster',
  'games.math.memoryMatch.step4Title': 'Win the game',
  'games.math.memoryMatch.step4Desc': 'Match all pairs in the fewest moves',

  // Per-page title/description for <title>/<meta description> (see SeoHead.tsx) -- before this,
  // every public page showed the same generic title/description as the homepage (fixed in
  // index.html), regardless of that page's actual content.
  'seo.home.title': 'TutorAI Kids - Smart AI Tutoring for Kids',
  'seo.home.description': 'An AI-powered learning platform that helps kids with their homework. Our tutor guides with questions to build critical thinking, with progress tracking, homework analysis, and an achievement system.',
  'seo.planes.title': 'Pricing Plans - TutorAI Kids',
  'seo.planes.description': 'Choose the perfect plan for your family: Basic, Family, or Premium. AI-powered tutoring, homework help, and educational games for kids.',
  'seo.faq.title': 'Frequently Asked Questions - TutorAI Kids',
  'seo.faq.description': 'Answers to common questions about TutorAI Kids: pricing, safety, how the AI tutor works, and more.',
  'seo.guiasPadres.title': 'Parent Guides - TutorAI Kids',
  'seo.guiasPadres.description': "Helpful guides for parents on supporting your child's learning, homework habits, and getting the most out of TutorAI Kids.",
  'seo.privacidad.title': 'Privacy Policy - TutorAI Kids',
  'seo.privacidad.description': "Learn how TutorAI Kids collects, uses, and protects your family's information, including our COPPA-compliant practices for children's privacy.",
  'seo.terminos.title': 'Terms of Service - TutorAI Kids',
  'seo.terminos.description': 'The terms and conditions for using TutorAI Kids, including subscription details, parental consent, and acceptable use.',
  'seo.accesibilidad.title': 'Accessibility Statement - TutorAI Kids',
  'seo.accesibilidad.description': 'Our commitment to making TutorAI Kids accessible to all children and families, including assistive technology support.',
  'seo.demo.title': 'Try the Demo - TutorAI Kids',
  'seo.demo.description': "See how TutorAI Kids' AI tutor guides kids through homework with a live interactive demo conversation.",
  'seo.about.title': 'About Us - TutorAI Kids',
  'seo.about.description': 'Learn who operates TutorAI Kids, our Socratic AI-tutoring approach, and how to contact our team.',

  // "About Us" page -- adds an authority/trust (E-E-A-T) signal the site was missing: there
  // was previously no public page stating who operates the product.
  'about.badge': 'About Us',
  'about.title': 'About TutorAI Kids',
  'about.subtitle': 'An AI tutor that helps kids think, not one that gives the answers.',
  'about.intro': "TutorAI Kids is a product by Neo AI Estudio, built to support school-age kids with a guided-questioning method that builds critical thinking instead of just handing over answers. The platform is fully bilingual (English and Spanish) and gives parents real visibility into their child's progress.",
  'about.approach.title': 'Our Approach',
  'about.approach.text': "Instead of solving the homework for the child, TutorAI Kids guides with questions, following a Socratic method, so the child arrives at the answer on their own. Parents get progress reports and can see what their child is working on.",
  'about.company.title': 'Who Operates TutorAI Kids',
  'about.company.text': 'This service is operated by Neo AI Estudio.',
  'about.contact.title': 'Contact Us',
  'about.contact.text': 'Have questions about the product, privacy, or need support? Reach out to us.',
  'about.contact.generalEmail': 'General support',
  'about.contact.privacyEmail': 'Privacy',
  'about.contact.legalEmail': 'Legal matters',
  'about.contact.whatsapp': 'WhatsApp',

  // Blog section -- fills the content gap the SEO audit found (no blog, Parent Guides was a
  // single static page). The posts themselves live as .md files in src/content/blog/ (see
  // blog.ts), not in this dictionary -- only the UI "chrome" (index, back button, etc.) goes
  // through i18n.
  'seo.blog.title': 'Blog - TutorAI Kids',
  'seo.blog.description': 'Articles on AI tutoring, homework help, and supporting your child\'s learning, from the TutorAI Kids team.',
  'blog.title': 'Blog',
  'blog.subtitle': 'Practical ideas on AI tutoring, homework, and supporting your child\'s learning.',
  'blog.readMore': 'Read more',
  'blog.backToBlog': 'Back to blog',
  'blog.empty': "We'll be publishing here soon.",
};
